module.exports = {
	recorridoData: () => {
		return [
			{
				START: {
					Image: require('./../assets/panoramas/Desktop/General_04.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '-8.598 -0.129 -4.817',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA ESCAPE',
						},
						{
							Position: '8.890 -0.129 6.549',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA F150',
						},
						{
							Position: '9.204 -0.129 -12.409',
							Rotation: '-95 180 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA MUSTANG',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '7.815 -0.129 0.353',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL3',
						},
						{
							Position: '18.090 -0.129 0.012',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL2',
						},
						{
							Position: '-1.306 0.568 -18.506',
							Rotation: '-80 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL5',
						},
					],
					BulletsIndividual: [],
				},
				GENERAL1: {
					Image: require('./../assets/panoramas/Desktop/General_01.webp'),
					Rotation: '0 120 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '-6.243 0.227 -5.695',
							Rotation: '-90 0 0',
							Scale: '0.7 0.7',
							goTo: 'GENERAL2',
						},
					],
					BulletsIndividual: [],
				},
				GENERAL2: {
					Image: require('./../assets/panoramas/Desktop/General_02.webp'),
					Rotation: '0 120 0',
					Bullets: [
						{
							Position: '6.082 -0.129 -12.186',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA EXPLORER',
						},
						{
							Position: '-0.174 -0.129 -13.303',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA BRONCO',
						},
						{
							Position: '-16.541 -0.129 6.236',
							Rotation: '-90 0 0',
							Scale: '0.7 0.7',
							goTo: 'FAMILIA F150',
						},
						{
							Position: '-19.184 -0.257 -12.161',
							Rotation: '-90 0 0',
							Scale: '0.7 0.7',
							goTo: 'FAMILIA MUSTANG',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '-12.122 -0.963 0.088',
							Rotation: '-90 0 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL3',
						},
						{
							Position: '-26.792 -0.119 0.062',
							Rotation: '-100 -90 0',
							Scale: '0.5 0.5',
							goTo: 'START',
						},
						{
							Position: '11.531 0.058 5.887',
							Rotation: '-90 0 0',
							Scale: '0.6 0.6',
							goTo: 'GENERAL1',
						},
						{
							Position: '0.186 -0.963 -32.741',
							Rotation: '-95 180 0',
							Scale: '0.7 0.7',
							goTo: 'GENERAL7',
						},
					],
					BulletsIndividual: [],
				},
				GENERAL3: {
					Image: require('./../assets/panoramas/Desktop/General_03.webp'),
					Rotation: '0 120 0',
					Bullets: [
						{
							Position: '-21.422 -0.139 -0.703',
							Rotation: '-100 -90 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA ESCAPE',
						},
						{
							Position: '-3.279 -0.129 7.654',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA F150',
						},
						{
							Position: '-3.037 -0.129 -10.516',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA MUSTANG',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '7.020 0.058 0.363',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL2',
						},
						{
							Position: '-10.165 0.058 0.373',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
						{
							Position: '20.476 0.058 4.097',
							Rotation: '-100 90 0',
							Scale: '0.7 0.7',
							goTo: 'GENERAL1',
						},
					],
					BulletsIndividual: [],
				},
				GENERAL5: {
					Image: require('./../assets/panoramas/Desktop/General_05.webp'),
					Rotation: '0 120 0',
					Bullets: [
						{
							Position: '-12.770 -0.129 9.733',
							Rotation: '-95 -45 0',
							Scale: '0.4 0.4',
							goTo: 'EXPEDITION LIMITED',
						},
						{
							Position: '-12.072 -0.129 22.112',
							Rotation: '-95 -45 0',
							Scale: '0.6 0.6',
							goTo: 'FAMILIA ESCAPE',
						},
						{
							Position: '6.778 -0.129 13.794',
							Rotation: '-100 45 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA MUSTANG',
						},
						{
							Position: '17.536 -0.129 -5.349',
							Rotation: '-95 90 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA RANGER',
						},
						{
							Position: '8.721 -0.129 -5.154',
							Rotation: '-90 90 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA RANGER2',
						},
						{
							Position: '-12.350 -0.139 1.130',
							Rotation: '-95 -90 0',
							Scale: '0.5 0.5',
							goTo: 'FAMILIA EDGE',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '7.020 0.058 0.363',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL6',
						},
						{
							Position: '-4.036 0.058 22.430',
							Rotation: '-95 0 0',
							Scale: '0.7 0.7',
							goTo: 'START',
						},
						{
							Position: '25.509 0.058 0.667',
							Rotation: '-100 90 0',
							Scale: '0.7 0.7',
							goTo: 'GENERAL7',
						},
					],
					BulletsIndividual: [],
				},
				GENERAL6: {
					Image: require('./../assets/panoramas/Desktop/General_06.webp'),
					Rotation: '0 120 0',
					Bullets: [
						{
							Position: '11.713 -0.129 -6.754',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA RANGER',
						},
						{
							Position: '-1.474 -0.129 -6.754',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA RANGER2',
						},
						{
							Position: '17.647 -0.129 8.957',
							Rotation: '-100 90 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA EXPLORER',
						},
						{
							Position: '-6.061 -0.129 15.161',
							Rotation: '-100 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA MUSTANG',
						},
						{
							Position: '-22.534 -0.129 -1.213',
							Rotation: '-95.010 -90.000 0',
							Scale: '0.5 0.5',
							goTo: 'FAMILIA EDGE',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '-13.058 0.058 0.363',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL5',
						},
						{
							Position: '10.007 0.058 -0.416',
							Rotation: '-100 90 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL7',
						},
						{
							Position: '-1.874 0.058 25.617',
							Rotation: '-100 0 0',
							Scale: '0.7 0.7',
							goTo: 'GENERAL3',
						},
					],
					BulletsIndividual: [],
				},
				GENERAL7: {
					Image: require('./../assets/panoramas/Desktop/General_07.webp'),
					Rotation: '0 120 0',
					Bullets: [
						{
							Position: '7.203 -0.129 10.159',
							Rotation: '-100 45 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA EXPLORER',
						},
						{
							Position: '-3.187 -0.129 13.633',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA BRONCO',
						},
						{
							Position: '-17.612 -0.129 14.414',
							Rotation: '-100 -45 0',
							Scale: '0.5 0.5',
							goTo: 'FAMILIA MUSTANG',
						},
						{
							Position: '-10.894 -0.129 -6.363',
							Rotation: '-95 -90 0',
							Scale: '0.5 0.5',
							goTo: 'FAMILIA RANGER2',
						},
						{
							Position: '2.906 -0.129 -5.214',
							Rotation: '-90 -90 0',
							Scale: '0.5 0.5',
							goTo: 'FAMILIA RANGER',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '-0.598 0.058 19.551',
							Rotation: '-100 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL2',
						},
						{
							Position: '-7.982 0.058 -0.001',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL6',
						},
						{
							Position: '-19.909 0.058 -0.001',
							Rotation: '-100 -90 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL5',
						},
					],
					BulletsIndividual: [],
				},

				'FAMILIA ESCAPE': {
					Image: require('./../assets/panoramas/Desktop/EscapeFamilia.webp'),
					Rotation: '0 90 0',
					Category: 'CAMIONETAS',
					Family: 'ESCAPE',
					Bullets: [
						{
							Position: '8.947 -0.129 17.532',
							Rotation: '-95 45 0',
							Scale: '0.5 0.5',
							goTo: 'FAMILIA F150',
						},
						{
							Position: '4.507 -0.129 -15.752',
							Rotation: '-95 180 0',
							Scale: '0.5 0.5',
							goTo: 'EXPEDITION LIMITED',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '5.253 -0.129 5.652',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
						{
							Position: '17.038 -0.129 12.731',
							Rotation: '-95 45 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL3',
						},
					],
					BulletsIndividual: [
						{
							Position: '-7.487 -0.129 13.093',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE ECOBOOST',
						},
						{
							Position: '-6.314 -0.129 3.799',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SE 4X2 FHEV',
						},
						{
							Position: '-3.266 -0.129 -4.463',
							Rotation: '-95 180 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SEL 4X2 FHEV',
						},
						{
							Position: '1.208 -0.129 -11.085',
							Rotation: '-95 180 0',
							Scale: '0.5 0.5',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV',
						},
					],
				},
				'FAMILIA F150': {
					Image: require('./../assets/panoramas/Desktop/F-150Familia.webp'),
					Rotation: '0 90 0',
					Category: 'PICK-UPS',
					Family: 'F-150',
					Bullets: [
						{
							Position: '-3.207 -0.129 -19.098',
							Rotation: '-86.913 62.941 -109.276',
							Scale: '0.892 0.892',
							goTo: 'FAMILIA ESCAPE',
						},
						{
							Position: '12.932 -0.129 -7.758',
							Rotation: '-86.392 -67.086 20.826',
							Scale: '0.611 0.611',
							goTo: 'FAMILIA MUSTANG',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '4.981 -0.129 -6.614',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
						{
							Position: '9.495 -0.129 2.582',
							Rotation: '-90 0 0',
							Scale: '0.558 0.558',
							goTo: 'GENERAL3',
						},
						{
							Position: '17.417 -0.129 13.910',
							Rotation: '-86.563 -90.000 53.772',
							Scale: '0.845 0.845',
							goTo: 'GENERAL2',
						},
					],
					BulletsIndividual: [
						{
							Position: '-4.270 -0.129 4.643',
							Rotation: '-95 45 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 XLT FHEV',
						},
						{
							Position: '-1.057 -0.129 10.644',
							Rotation: '-95 45 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 PLATINUM FHEV',
						},
						{
							Position: '-5.101 -0.129 -2.514',
							Rotation: '-95 45 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 RAPTOR',
						},
						{
							Position: '-6.389 -0.129 -8.975',
							Rotation: '-87.639 44.182 -153.952',
							Scale: '0.6 0.6',
							goTo: 'F-150 LARIAT SPORT',
						},
					],
				},
				'FAMILIA EDGE': {
					Image: require('./../assets/panoramas/Desktop/EdgeFamilia.webp'),
					Rotation: '0 90 0',
					Category: 'CAMIONETAS',
					Family: 'EDGE',
					Bullets: [
						{
							Position: '1.792 -0.129 13.147',
							Rotation: '-95 45 0',
							Scale: '0.5 0.5',
							goTo: 'EXPEDITION LIMITED',
						},
						{
							Position: '15.111 -0.129 -18.131',
							Rotation: '-85.148 -29.043 74.506',
							Scale: '0.778 0.778',
							goTo: 'FAMILIA RANGER',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '2.887 -0.129 -2.020',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL5',
						},
						{
							Position: '16.806 -0.129 19.774',
							Rotation: '-85.585 -145.765 -161.991',
							Scale: '0.763 0.763',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-3.249 -0.129 4.940',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE ST',
						},
						{
							Position: '-5.833 -0.129 -4.849',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE SEL',
						},
					],
				},
				'FAMILIA MUSTANG': {
					Image: require('./../assets/panoramas/Desktop/MustangFamilia.webp'),
					Rotation: '0 90 0',
					Category: 'AUTOMÓVILES',
					Family: 'MUSTANG',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '-0.966 -0.129 10.954',
							Rotation: '-85.961 180.000 180.000',
							Scale: '0.5 0.5',
							goTo: 'GENERAL3',
						},
						{
							Position: '-0.966 -0.129 -14.495',
							Rotation: '66.684 0 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL6',
						},
					],
					BulletsIndividual: [
						{
							Position: '-10.468 -0.129 1.887',
							Rotation: '-87.082 90.000 -90.000',
							Scale: '0.6 0.6',
							alt: true,
							goTo: 'MUSTANG MACH 1',
						},
						{
							Position: '-11.269 -0.165 -1.947',
							Rotation: '-87.082 90.000 -90.000',
							Scale: '0.6 0.6',
							alt: true,
							goTo: 'MUSTANG GT PREMIUM',
						},
					],
				},
				'FAMILIA BRONCO': {
					Image: require('./../assets/panoramas/Desktop/BroncoFamilia.webp'),
					Rotation: '0 90 0',
					Category: 'CAMIONETAS',
					Family: 'BRONCO SPORT',
					Bullets: [
						{
							Position: '7.763 -0.165 -1.947',
							Rotation: '-85.961 180.000 180.000',
							Scale: '0.5 0.5',
							goTo: 'FAMILIA EXPLORER',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '-0.966 -0.129 10.954',
							Rotation: '-85.961 180.000 180.000',
							Scale: '0.5 0.5',
							goTo: 'GENERAL2',
						},
						{
							Position: '-0.966 -0.129 -14.495',
							Rotation: '66.684 0 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL7',
						},
					],
					BulletsIndividual: [
						{
							Position: '-10.468 -0.129 1.887',
							Rotation: '-87.082 90.000 -90.000',
							Scale: '0.6 0.6',
							alt: true,
							goTo: 'BRONCO SPORT WILDTRAK',
						},
						{
							Position: '-11.269 -0.165 -1.947',
							Rotation: '-87.082 90.000 -90.000',
							Scale: '0.6 0.6',
							alt: true,
							goTo: 'BRONCO SPORT BIG BEND',
						},
					],
				},

				'FAMILIA RANGER': {
					Image: require('./../assets/panoramas/Desktop/RangerFamilia.webp'),
					Rotation: '0 90 0',
					Category: 'PICK-UPS',
					Family: 'RANGER',
					Bullets: [
						{
							Position: '25.272 -0.783 -9.926',
							Rotation: '-90 0 0',
							Scale: '0.7 0.7',
							goTo: 'FAMILIA EXPLORER',
						},
						{
							Position: '25.272 -0.783 4.590',
							Rotation: '-85.153 -69.387 -39.344',
							Scale: '0.7 0.7',
							goTo: 'FAMILIA BRONCO',
						}
					],
					BulletsDesplazamiento: [
						{
							Position: '3.784 -0.129 11.872',
							Rotation: '-90 0 0',
							Scale: '0.7 0.7',
							goTo: 'GENERAL6',
						},
						{
							Position: '2.699 -0.129 1.726',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL7',
						},
						{
							Position: '6.486 -0.129 26.953',
							Rotation: '-90 0 0',
							Scale: '0.662 0.662',
							goTo: 'GENERAL5',
						},
					],
					BulletsIndividual: [
						{
							Position: '-4.048 -0.129 -1.570',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLS DIESEL',
						},
						{
							Position: '5.941 -0.129 -5.130',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL CHASIS',
						},
						{
							Position: '-5.547 -0.129 4.599',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED BLACK EDITION',
						},
						{
							Position: '-0.604 -0.129 -4.715',
							Rotation: '-85.772 180 -135.000',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL',
						},
						{
							Position: '-4.814 -0.129 9.356',
							Rotation: '-85.772 180 -135.000',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED',
						},
						{
							Position: '-3.516 -0.129 16.855',
							Rotation: '-85.772 180 -135.000',
							Scale: '0.4 0.4',
							goTo: 'RANGER FX4',
						},
					],
				},
				'FAMILIA RANGER2': {
					Image: require('./../assets/panoramas/Desktop/RangerFamilia_02.webp'),
					Rotation: '0 90 0',
					Category: 'PICK-UPS',
					Family: 'RANGER',
					Bullets: [
						{
							Position: '22.533 -0.783 8.469',
							Rotation: '-90.000 0 0',
							Scale: '0.845 0.845',
							goTo: 'FAMILIA MUSTANG',
						},
						{
							Position: '-0.548 -0.783 -16.265',
							Rotation: '-90.000 0 0',
							Scale: '0.7 0.7',
							goTo: 'FAMILIA RANGER',
						}
					],
					BulletsDesplazamiento: [
						{
							Position: '3.784 -0.129 -1.377',
							Rotation: '-90 0 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL6',
						},
						{
							Position: '8.857 -0.129 -12.209',
							Rotation: '-90 0 0',
							Scale: '0.6 0.6',
							goTo: 'GENERAL7',
						},
						{
							Position: '-0.842 -0.129 9.778',
							Rotation: '-90 0 0',
							Scale: '0.662 0.662',
							goTo: 'GENERAL5',
						},
					],
					BulletsIndividual: [
						{
							Position: '-4.929 -0.129 10.284',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLT',
						},
						{
							Position: '-5.773 -0.129 2.851',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER FX4',
						},
						{
							Position: '-5.305 -0.129 -5.400',
							Rotation: '-90 180 -135.000',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED',
						},
						{
							Position: '-4.197 -0.129 -10.183',
							Rotation: '-90 180 -135.000',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED BLACK EDITION',
						},
					],
				},
				'FAMILIA EXPLORER': {
					Image: require('./../assets/panoramas/Desktop/ExplorerFamilia.webp'),
					Rotation: '0 90 0',
					Category: 'CAMIONETAS',
					Family: 'EXPLORER',
					Bullets: [
						{
							Position: '8.133 -0.129 7.393',
							Rotation: '-90 45 0',
							Scale: '0.5 0.5',
							goTo: 'FAMILIA BRONCO',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '2.685 -0.129 12.649',
							Rotation: '-87.978 180.000 -135.000',
							Scale: '0.4 0.4',
							goTo: 'GENERAL7',
						},
						{
							Position: '2.685 -0.129 -12.239',
							Rotation: '-84.185 0 45',
							Scale: '0.4 0.4',
							goTo: 'GENERAL2',
						},
					],
					BulletsIndividual: [
						{
							Position: '-4.796 -0.129 -7.613',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER XLT',
						},
						{
							Position: '-4.796 -0.129 1.359',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER ST',
						},
						{
							Position: '-4.796 -0.129 12.069',
							Rotation: '-85.772 180 -135.000',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER LIMITED',
						},
					],
				},

				'ESCAPE TITANIUM 4X4 FHEV': {
					Image: require('./../assets/panoramas/Desktop/EscapeHibridaTitanium_Frente.webp'),
					Rotation: '0 90 0',
					Vehiculo: 'ESCAPE TITANIUM 4X4 FHEV',
					Bullets: [
						{
							Position: '2.451 -0.129 10.013',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA ESCAPE',
						},
						{
							Position: '-1.272 -0.129 -7.263',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPEDITION LIMITED',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '8.929 -0.129 14.148',
							Rotation: '-95 10 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
						{
							Position: '8.929 -0.129 -19.437',
							Rotation: '-95 180 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL5',
						},
					],
					BulletsIndividual: [
						{
							Position: '-2.467 -0.129 -1.576',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV DIG IZQ',
						},
						{
							Position: '-6.812 -0.119 3.239',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV LAT DER',
						},
						{
							Position: '-6.366 -0.119 -3.487',
							Rotation: '-90 180 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV LAT IZQ',
						},
						{
							Position: '-1.265 -0.129 6.445',
							Rotation: '-95 180 0',
							Scale: '0.5 0.5',
							goTo: 'ESCAPE SEL 4X2 FHEV',
						},
						{
							Position: '0.702 -0.129 15.553',
							Rotation: '-95 180 0',
							Scale: '0.5 0.5',
							goTo: 'ESCAPE SE 4X2 FHEV',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.563 1.049',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema de iluminación con tecnología LED. la Nueva Escape posee faros delanteros LED (versión Titanium), más eficientes, y que se encienden o apagan automáticamente al controlarse mediante un sensor de luz. Así mismo la Nueva Escape incorpora luces altas automáticas, con las cuales logras la visibilidad necesaria en carretera, sin incomodar a los demás conductores.',
							Image: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/01_Bullets/Bullet 06.webp'),
						},
						{
							Position: '-3.826 -0.199 0.055',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema de rejillas activas. Se abren y cierran de forma automática para mejorar la aerodinámica y la eficiencia de consumo de combustible.',
							Image: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/01_Bullets/bullet10.webp'),
						},
						{
							Position: '-3.826 0.424 -1.197',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Complementando el sistema de permanencia en el carril, en las versiones SEL y Titanium este sistema no solo te ayuda a mantenerte dentro del carril, sino que también ayuda a mantener el vehículo centrado en el mismo.',
							Image: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/01_Bullets/bullet9.webp'),
						},
					],
				},
				'ESCAPE TITANIUM 4X4 FHEV DIG DER': {
					Image: require('./../assets/panoramas/Desktop/EscapeHibridaTitanium_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '-7.863 -0.129 -19.048',
							Rotation: '-95 -140 0',
							Scale: '0.5 0.5',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-2.948 -0.129 1.608',
							Rotation: '-95 0 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV POSTERIOR',
						},
						{
							Position: '-3.781 -0.129 -2.008',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV LAT DER',
						},
						{
							Position: '-3.228 -0.129 -9.176',
							Rotation: '-90 180 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SEL 4X2 FHEV',
						},
					],
				},
				'ESCAPE TITANIUM 4X4 FHEV DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/EscapeHibridaTitanium_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '-3.729 -0.129 11.679',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA ESCAPE',
						},
						{
							Position: '2.341 -0.129 -4.345',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPEDITION LIMITED',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '-3.131 -0.129 18.936',
							Rotation: '-90 0 0',
							Scale: '0.5 0.5',
							goTo: 'START',
						},
						{
							Position: '14.682 -0.129 -6.967',
							Rotation: '-90 0 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL5',
						},
					],
					BulletsIndividual: [
						{
							Position: '-0.987 -0.129 1.850',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV',
						},
						{
							Position: '-3.639 -0.129 -2.400',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV LAT IZQ',
						},
						{
							Position: '-5.998 -0.129 6.882',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SEL 4X2 FHEV',
						},
						{
							Position: '3.369 -0.129 -14.880',
							Rotation: '-95 180 0',
							Scale: '0.5 0.5',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.651 0.328',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Este sistema no solo te alerta, sino que también ayuda a mantener el vehículo dentro del carril. Incluído en Ford Co-Pilot360™ . Disponible en la versión Titanium.',
							Image: require('./../assets/Galerias/04_EscapeHibrida4x4Titanium/01_Bullets/bullet9.webp'),
						},
					],
				},
				'ESCAPE TITANIUM 4X4 FHEV LAT DER': {
					Image: require('./../assets/panoramas/Desktop/EscapeHibridaTitanium_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '6.912 -0.129 -10.761',
							Rotation: '-95 -180 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-4.608 -0.129 -4.605',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV',
						},
						{
							Position: '-4.608 -0.129 4.016',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV POSTERIOR',
						},
						{
							Position: '-2.883 -0.447 2.834',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV DIG DER',
						},
						{
							Position: '3.199 -0.129 -4.183',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SEL 4X2 FHEV',
						},
					],
				},
				'ESCAPE TITANIUM 4X4 FHEV LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/EscapeHibridaTitanium_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '2.378 -0.129 3.620',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPEDITION LIMITED',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '-18.220 -0.129 11.213',
							Rotation: '-95 270 0',
							Scale: '0.5 0.5',
							goTo: 'START',
						},
						{
							Position: '8.095 -0.129 11.568',
							Rotation: '-95 45 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL5',
						},
					],
					BulletsIndividual: [
						{
							Position: '-2.841 -0.129 2.565',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV DIG DER',
						},
						{
							Position: '-5.066 -0.129 4.137',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV',
						},
						{
							Position: '-5.066 -0.129 -4.165',
							Rotation: '-95 180 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV POSTERIOR',
						},
					],
				},
				'ESCAPE TITANIUM 4X4 FHEV POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/EscapeHibridaTitanium_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '-8.598 -0.129 7.622',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPEDITION LIMITED',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '-14.859 -0.129 -10.844',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-4.256 -0.129 -2.550',
							Rotation: '-90 0 0',
							Scale: '0.35 0.35',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV LAT DER',
						},
						{
							Position: '-4.256 -0.129 2.454',
							Rotation: '-90 0 0',
							Scale: '0.35 0.35',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV LAT IZQ',
						},
						{
							Position: '-8.394 -0.129 -8.143',
							Rotation: '-95 180 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SEL 4X2 FHEV',
						},
						{
							Position: '-1.719 -0.129 -1.778',
							Rotation: '-95 180 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV DIG DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 -0.351 -0.001',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Apertura eléctrica de baúl con función de manos libres. No importa que tengas las manos ocupadas. Basta con pasar el pie por debajo de la defensa trasera para que la puerta del baúl se abra o se cierre por si sola. Es necesario tener la llave de acceso inteligente cerca.',
							Image: require('./../assets/Galerias/03_EscapeSEL4X2HEV/01_Bullets/Bullet 07.webp'),
						},
					],
				},

				'ESCAPE ECOBOOST': {
					Image: require('./../assets/panoramas/Desktop/EscapeEcoboostTitanium_Frente.webp'),
					Rotation: '0 90 0',
					Vehiculo: 'ESCAPE ECOBOOST',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '9.147 -0.129 -3.086',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-1.682 -0.129 -1.656',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE ECOBOOST DIG IZQ',
						},
						{
							Position: '-5.384 -0.129 -2.614',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE ECOBOOST LAT IZQ',
						},
						{
							Position: '-5.374 -0.129 3.036',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE ECOBOOST LAT DER',
						},
						{
							Position: '1.571 -0.129 -8.695',
							Rotation: '-90 0 0',
							Scale: '0.5 0.5',
							goTo: 'ESCAPE SE 4X2 FHEV',
						},
						{
							Position: '5.214 -0.129 -16.882',
							Rotation: '-83.961 -21.939 -14.429',
							Scale: '0.6 0.6',
							goTo: 'ESCAPE SEL 4X2 FHEV',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.563 1.249',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: ' Ya no hay que preocuparse por encender o apagar las luces, la Nueva Escape posee faros delanteros LED más eficientes, y que se encienden o apagan automáticamente al controlarse mediante un sensor de luz. Así mismo la Nueva Escape incorpora luces altas automáticas, con las cuales logras la visibilidad necesaria en carretera, sin incomodar a los demás conductores. Disponible en la versión Titanium.',
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 06.webp'),
						},
						{
							Position: '-3.826 0.651 -0.096',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Nueva Escape cuenta con la nueva generación de motores turbo-cargados Ecoboost de Ford. Su potente motor turbo de 2.0L es capaz de desarrollar impresionantes 250 hp y 280 lb-pie de torque.',
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 06.webp'),
						},
						{
							Position: '-3.826 0.424 -1.197',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Este sistema no solo te alerta, sino que también ayuda a mantener el vehículo dentro del carril. Incluído en Ford Co-Pilot360™ . Disponible en la versión Titanium.',
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 10.webp'),
						},
					],
				},
				'ESCAPE ECOBOOST DIG DER': {
					Image: require('./../assets/panoramas/Desktop/EscapeEcoboostTitanium_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '-16.013 -0.129 -8.374',
							Rotation: '-90 0 0',
							Scale: '0.745 0.745',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-3.048 -0.129 1.757',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE ECOBOOST POSTERIOR',
						},
						{
							Position: '-4.427 -0.129 -1.952',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE ECOBOOST LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.132 -0.238',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Nueva Escape cuenta con un avanzado sistema de tracción integral, para enfrentar los terrenos más desafiantes. Disponible en la versión Titanium.',
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 09.webp'),
						},
						{
							Position: '-3.826 0.742 -1.413',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: "La Nueva Escape EcoBoost en su versión Titanium, cuenta con rines de 19' en aluminio maquinado.",
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 08.webp'),
						},
					],
				},
				'ESCAPE ECOBOOST DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/EscapeEcoboostTitanium_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '5.133 -0.129 3.397',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-2.589 -0.129 2.051',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE ECOBOOST',
						},
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE ECOBOOST LAT IZQ',
						},
						{
							Position: '5.752 -0.129 -3.973',
							Rotation: '-84.579 -89.990 90.000',
							Scale: '0.47 0.47',
							goTo: 'ESCAPE SE 4X2 FHEV',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.676 -1.413',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Nueva Escape cuenta con un avanzado sistema de tracción integral, para enfrentar los terrenos más desafiantes. Disponible en la versión Titanium.',
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 09.webp'),
						},
						{
							Position: '-3.826 0.651 0.328',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Este sistema no solo te alerta, sino que también ayuda a mantener el vehículo dentro del carril. Incluído en Ford Co-Pilot360™ . Disponible en la versión Titanium.',
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 10.webp'),
						},
						{
							Position: '-4.625 0.298 -0.296',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: "La Nueva Escape EcoBoost en su versión Titanium, cuenta con rines de 19' en aluminio maquinado.",
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 08.webp'),
						},
					],
				},
				'ESCAPE ECOBOOST LAT DER': {
					Image: require('./../assets/panoramas/Desktop/EscapeEcoboostTitanium_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '-6.661 -0.129 -12.377',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-4.608 -0.129 -4.605',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE ECOBOOST',
						},
						{
							Position: '-4.608 -0.129 4.016',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE ECOBOOST POSTERIOR',
						},
						{
							Position: '-2.883 -0.447 2.834',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE ECOBOOST DIG DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.132 1.484',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Nueva Escape cuenta con un avanzado sistema de tracción integral, para enfrentar los terrenos más desafiantes. Disponible en la versión Titanium.',
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 09.webp'),
						},
						{
							Position: '-3.826 0.132 -1.896',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: "La Nueva Escape EcoBoost en su versión Titanium, cuenta con rines de 19' en aluminio maquinado.",
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 08.webp'),
						},
					],
				},
				'ESCAPE ECOBOOST LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/EscapeEcoboostTitanium_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '-0.284 -0.129 13.073',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-5.474 -0.129 5.250',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE ECOBOOST',
						},
						{
							Position: '-2.708 -0.129 3.176',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE ECOBOOST DIG IZQ',
						},
						{
							Position: '-4.514 -0.129 -3.743',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE ECOBOOST POSTERIOR',
						},
						{
							Position: '3.916 -0.129 9.569',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SE 4X2 FHEV',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.132 -1.458',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Nueva Escape cuenta con un avanzado sistema de tracción integral, para enfrentar los terrenos más desafiantes. Disponible en la versión Titanium.',
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 09.webp'),
						},
						{
							Position: '-3.826 0.132 1.779',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: "La Nueva Escape EcoBoost en su versión Titanium, cuenta con rines de 19' en aluminio maquinado.",
							Image: require('./../assets/Galerias/01_EscapeEcoboost/01_Bullets/Bullet 08.webp'),
						},
					],
				},
				'ESCAPE ECOBOOST POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/EscapeEcoboostTitanium_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-2.116 -0.129 -1.382',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE ECOBOOST DIG DER',
						},
						{
							Position: '-5.552 -0.129 2.343',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE ECOBOOST LAT IZQ',
						},
						{
							Position: '-5.552 -0.129 -2.680',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE ECOBOOST LAT DER',
						},
						{
							Position: '-13.177 -0.129 9.790',
							Rotation: '-83.622 114.538 -114.404',
							Scale: '0.570 0.570',
							goTo: 'ESCAPE SE 4X2 FHEV',
						},
					],
				},

				'ESCAPE SE 4X2 FHEV': {
					Image: require('./../assets/panoramas/Desktop/EscapeSE_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '14.902 -0.129 15.994',
							Rotation: '-85.000 -159.155 0',
							Scale: '0.7 0.7',
							goTo: 'FAMILIA F150',
						},
						{
							Position: '10.473 -0.129 -18.268',
							Rotation: '-84.040 -17.379 -141.937',
							Scale: '0.532 0.532',
							goTo: 'EXPEDITION LIMITED',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '6.195 -0.129 4.080',
							Rotation: '-90 -125.081 19.798',
							Scale: '0.5 0.5',
							goTo: 'START',
						},
						{
							Position: '18.931 0.059 -17.510',
							Rotation: '-84.040 -17.379 -166.179',
							Scale: '0.726 0.726',
							goTo: 'GENERAL5',
						},
					],
					BulletsIndividual: [
						{
							Position: '-1.682 -0.129 -1.656',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE SE 4X2 FHEV DIG IZQ',
						},
						{
							Position: '-5.384 -0.129 -2.614',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SE 4X2 FHEV LAT IZQ',
						},
						{
							Position: '-5.374 -0.129 3.036',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SE 4X2 FHEV LAT DER',
						},
						{
							Position: '-4.070 -0.129 9.623',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE ECOBOOST',
						},
						{
							Position: '3.388 -0.129 -8.695',
							Rotation: '-90 0 0',
							Scale: '0.5 0.5',
							goTo: 'ESCAPE SEL 4X2 FHEV',
						},
						{
							Position: '7.961 -0.129 -14.354',
							Rotation: '-87.813 -36.444 0',
							Scale: '0.5 0.5',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.609 0.084',
							Rotation: '0 90 0',
							Scale: '0.05 0.05',
							Text: 'El asistente de manejo evasivo te ayuda a evitar una posibe colisión con un vehículo estacionado o que va más lento en frente Brinda asistencia adicional en la dirección cuando no hay tiempo para evitar una colisión o si se requiere maniobrar rápidamente.',
							Image: require('./../assets/Galerias/02_EscapeSE4X2HEV/01_Bullets/Bullet 06.webp'),
						},
						{
							Position: '-3.826 -0.199 0.055',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema de rejillas activas. Se abren y cierran de forma automática para mejorar la aerodinámica y la eficiencia de consumo de combustible.',
							Image: require('./../assets/Galerias/02_EscapeSE4X2HEV/01_Bullets/Bullet 10.webp'),
						},
						{
							Position: '-3.826 0.424 -1.197',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Complementando el sistema de permanencia en el carril, en las versiones SEL y Titanium este sistema no solo te ayuda a mantenerte dentro del carril, sino que también ayuda a mantener el vehículo centrado en el mismo.',
							Image: require('./../assets/Galerias/02_EscapeSE4X2HEV/01_Bullets/Bullet 09.webp'),
						},
					],
				},
				'ESCAPE SE 4X2 FHEV DIG DER': {
					Image: require('./../assets/panoramas/Desktop/EscapeSE_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '-10.908 -0.129 -11.125',
							Rotation: '-85.214 58.972 -59.060',
							Scale: '0.709 0.709',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-3.048 -0.129 1.757',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE SE 4X2 FHEV POSTERIOR',
						},
						{
							Position: '-4.427 -0.129 -1.952',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE SE 4X2 FHEV LAT DER',
						},
						{
							Position: '-0.430 -0.129 -7.330',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE ECOBOOST',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.508 0.196',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema de monitoreo de punto ciego BLIS y alerta de tráfico cruzado. Detecta cuando otro vehículo está en el carril contiguo dentro del punto ciego de la Nueva Escape, alertándote por medio de una luz en los espejos laterales. Este sistema también detecta el punto ciego de un tráiler, en caso de venir remolcando uno. La alerta de tráfico cruzado detecta vehículos cuando se está retrocediendo lentamente, ideal al salir de un estacionamiento.',
							Image: require('./../assets/Galerias/02_EscapeSE4X2HEV/01_Bullets/Bullet 07.webp'),
						},
					],
				},
				'ESCAPE SE 4X2 FHEV DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/EscapeSE_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '7.260 -0.129 5.515',
							Rotation: '-90 0 0',
							Scale: '0.503 0.503',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-2.589 -0.129 2.051',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SE 4X2 FHEV',
						},
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SE 4X2 FHEV LAT IZQ',
						},
						{
							Position: '-10.710 -0.129 6.790',
							Rotation: '-84.667 90.000 -89.990',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE ECOBOOST',
						},
						{
							Position: '7.108 -0.129 -2.012',
							Rotation: '-84.579 -89.990 90.000',
							Scale: '0.47 0.47',
							goTo: 'ESCAPE SEL 4X2 FHEV',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.148 -1.413',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema de monitoreo de punto ciego BLIS y alerta de tráfico cruzado. Detecta cuando otro vehículo está en el carril contiguo dentro del punto ciego de la Nueva Escape, alertándote por medio de una luz en los espejos laterales. Este sistema también detecta el punto ciego de un tráiler, en caso de venir remolcando uno. La alerta de tráfico cruzado detecta vehículos cuando se está retrocediendo lentamente, ideal al salir de un estacionamiento.',
							Image: require('./../assets/Galerias/02_EscapeSE4X2HEV/01_Bullets/Bullet 07.webp'),
						},
						{
							Position: '-3.826 0.651 0.328',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Este sistema no solo te alerta, sino que también ayuda a mantener el vehículo dentro del carril. Incluído en Ford Co-Pilot360™ . Disponible en la versión Titanium.',
							Image: require('./../assets/Galerias/02_EscapeSE4X2HEV/01_Bullets/Bullet 09.webp'),
						},
					],
				},
				'ESCAPE SE 4X2 FHEV LAT DER': {
					Image: require('./../assets/panoramas/Desktop/EscapeSE_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '-0.370 -0.129 -12.311',
							Rotation: '-90 0 0',
							Scale: '0.6 0.6',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-4.608 -0.129 -4.605',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SE 4X2 FHEV',
						},
						{
							Position: '-4.608 -0.129 4.016',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SE 4X2 FHEV POSTERIOR',
						},
						{
							Position: '-2.883 -0.447 2.834',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SE 4X2 FHEV DIG DER',
						},
						{
							Position: '4.646 -0.129 -1.074',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE ECOBOOST',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.689 2.050',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema de monitoreo de punto ciego BLIS y alerta de tráfico cruzado. Detecta cuando otro vehículo está en el carril contiguo dentro del punto ciego de la Nueva Escape, alertándote por medio de una luz en los espejos laterales. Este sistema también detecta el punto ciego de un tráiler, en caso de venir remolcando uno. La alerta de tráfico cruzado detecta vehículos cuando se está retrocediendo lentamente, ideal al salir de un estacionamiento.',
							Image: require('./../assets/Galerias/02_EscapeSE4X2HEV/01_Bullets/Bullet 07.webp'),
						},
					],
				},
				'ESCAPE SE 4X2 FHEV LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/EscapeSE_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '-8.598 -0.129 10.245',
							Rotation: '-90 0 0',
							Scale: '0.585 0.585',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-5.474 -0.129 5.250',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SE 4X2 FHEV',
						},
						{
							Position: '-2.708 -0.129 3.176',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SE 4X2 FHEV DIG IZQ',
						},
						{
							Position: '-4.514 -0.129 -3.743',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SE 4X2 FHEV POSTERIOR',
						},
						{
							Position: '3.916 -0.129 9.569',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SEL 4X2 FHEV',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.816 -1.955',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema de monitoreo de punto ciego BLIS y alerta de tráfico cruzado. Detecta cuando otro vehículo está en el carril contiguo dentro del punto ciego de la Nueva Escape, alertándote por medio de una luz en los espejos laterales. Este sistema también detecta el punto ciego de un tráiler, en caso de venir remolcando uno. La alerta de tráfico cruzado detecta vehículos cuando se está retrocediendo lentamente, ideal al salir de un estacionamiento.',
							Image: require('./../assets/Galerias/02_EscapeSE4X2HEV/01_Bullets/Bullet 07.webp'),
						},
					],
				},
				'ESCAPE SE 4X2 FHEV POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/EscapeSE_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '-15.394 -0.129 -8.478',
							Rotation: '-85.910 90.000 -114.101',
							Scale: '0.7 0.7',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-2.116 -0.129 -1.382',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE SE 4X2 FHEV DIG DER',
						},
						{
							Position: '-5.552 -0.129 2.343',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE SE 4X2 FHEV LAT IZQ',
						},
						{
							Position: '-5.552 -0.129 -2.680',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE SE 4X2 FHEV LAT DER',
						},
						{
							Position: '-13.588 -0.129 8.537',
							Rotation: '-83.622 114.538 -114.404',
							Scale: '0.570 0.570',
							goTo: 'ESCAPE SE 4X2 FHEV',
						},
						{
							Position: '-5.612 -0.129 -9.617',
							Rotation: '-90 0 0',
							Scale: '0.473 0.473',
							goTo: 'ESCAPE ECOBOOST',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.322 -1.3405',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema de monitoreo de punto ciego BLIS y alerta de tráfico cruzado. Detecta cuando otro vehículo está en el carril contiguo dentro del punto ciego de la Nueva Escape, alertándote por medio de una luz en los espejos laterales. Este sistema también detecta el punto ciego de un tráiler, en caso de venir remolcando uno. La alerta de tráfico cruzado detecta vehículos cuando se está retrocediendo lentamente, ideal al salir de un estacionamiento.',
							Image: require('./../assets/Galerias/02_EscapeSE4X2HEV/01_Bullets/Bullet 07.webp'),
						},
					],
				},

				'ESCAPE SEL 4X2 FHEV': {
					Image: require('./../assets/panoramas/Desktop/EscapeSEL_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '8.753 -0.129 22.296',
							Rotation: '-85.000 -159.155 0',
							Scale: '0.7 0.7',
							goTo: 'FAMILIA F150',
						},
						{
							Position: '7.965 -0.129 -11.416',
							Rotation: '-85.191 -21.714 42.417',
							Scale: '0.6 0.6',
							goTo: 'EXPEDITION LIMITED',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '3.826 -0.129 10.610',
							Rotation: '-86.858 -125.081 19.798',
							Scale: '0.5 0.5',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-1.682 -0.129 -1.656',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE SEL 4X2 FHEV DIG IZQ',
						},
						{
							Position: '-5.384 -0.129 -2.614',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SEL 4X2 FHEV LAT IZQ',
						},
						{
							Position: '-5.374 -0.129 3.036',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SEL 4X2 FHEV LAT DER',
						},
						{
							Position: '-5.364 -0.129 8.913',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SE 4X2 FHEV',
						},
						{
							Position: '3.611 -0.129 -6.218',
							Rotation: '-95 0 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.609 0.084',
							Rotation: '0 90 0',
							Scale: '0.05 0.05',
							Text: 'El asistente de manejo evasivo te ayuda a evitar una posibe colisión con un vehículo estacionado o que va más lento en frente Brinda asistencia adicional en la dirección cuando no hay tiempo para evitar una colisión o si se requiere maniobrar rápidamente.',
							Image: require('./../assets/Galerias/03_EscapeSEL4X2HEV/01_Bullets/Bullet 06.webp'),
						},
						{
							Position: '-3.826 -0.199 0.055',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema de rejillas activas. Se abren y cierran de forma automática para mejorar la aerodinámica y la eficiencia de consumo de combustible.',
							Image: require('./../assets/Galerias/03_EscapeSEL4X2HEV/01_Bullets/Bullet 10.webp'),
						},
						{
							Position: '-3.826 0.424 -1.197',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Complementando el sistema de permanencia en el carril, en las versiones SEL y Titanium este sistema no solo te ayuda a mantenerte dentro del carril, sino que también ayuda a mantener el vehículo centrado en el mismo.',
							Image: require('./../assets/Galerias/03_EscapeSEL4X2HEV/01_Bullets/Bullet 09.webp'),
						},
					],
				},
				'ESCAPE SEL 4X2 FHEV DIG DER': {
					Image: require('./../assets/panoramas/Desktop/EscapeSEL_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '-1.112 -0.129 -13.668',
							Rotation: '-90 0 0',
							Scale: '0.712 0.712',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-3.048 -0.129 1.757',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE SEL 4X2 FHEV POSTERIOR',
						},
						{
							Position: '-4.427 -0.129 -1.952',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE SEL 4X2 FHEV LAT DER',
						},
						{
							Position: '1.072 -0.129 -7.330',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SE 4X2 FHEV',
						},
					],
				},
				'ESCAPE SEL 4X2 FHEV DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/EscapeSEL_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '10.901 -0.129 -0.864',
							Rotation: '-84.579 -89.990 90.000',
							Scale: '0.47 0.47',
							goTo: 'EXPEDITION LIMITED',
						},
						{
							Position: '-14.850 -1.726 42.038',
							Rotation: '-82.293 171.905 18.942',
							Scale: '1.494 1.494',
							goTo: 'FAMILIA F150',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '-7.066 -0.129 10.442',
							Rotation: '-90 0 0',
							Scale: '0.653 0.653',
							goTo: 'START',
						},
						{
							Position: '14.030 -0.129 3.492',
							Rotation: '-84.579 -89.990 90.000',
							Scale: '0.470 0.470',
							goTo: 'GENERAL5',
						},
					],
					BulletsIndividual: [
						{
							Position: '-2.589 -0.129 2.051',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SEL 4X2 FHEV',
						},
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SEL 4X2 FHEV LAT IZQ',
						},
						{
							Position: '-11.157 -0.129 5.701',
							Rotation: '-85.712 146.081 -115.038',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SE 4X2 FHEV',
						},
						{
							Position: '4.793 -0.129 0.445',
							Rotation: '-85.712 146.08 -115.038',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.651 0.328',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Este sistema no solo te alerta, sino que también ayuda a mantener el vehículo dentro del carril. Incluído en Ford Co-Pilot360™ . Disponible en la versión Titanium.',
							Image: require('./../assets/Galerias/03_EscapeSEL4X2HEV/01_Bullets/Bullet 09.webp'),
						},
					],
				},
				'ESCAPE SEL 4X2 FHEV LAT DER': {
					Image: require('./../assets/panoramas/Desktop/EscapeSEL_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '-14.822 -0.269 -12.293',
							Rotation: '-85.722 67.074 -67.112',
							Scale: '0.6 0.6',
							goTo: 'EXPEDITION LIMITED',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '6.985 -0.129 -4.817',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-4.608 -0.129 -4.605',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SEL 4X2 FHEV',
						},
						{
							Position: '-4.608 -0.129 4.016',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SEL 4X2 FHEV POSTERIOR',
						},
						{
							Position: '-2.883 -0.447 2.834',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SEL 4X2 FHEV DIG DER',
						},
						{
							Position: '4.442 -0.129 0.382',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SE 4X2 FHEV',
						},
					],
				},
				'ESCAPE SEL 4X2 FHEV LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/EscapeSEL_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '-17.822 -0.129 10.852',
							Rotation: '-86.751 124.365 -91.749',
							Scale: '0.747 0.747',
							goTo: 'START',
						},
						{
							Position: '5.8792 -0.129 29.921',
							Rotation: '-84.959 -161.258 82.494',
							Scale: '0.747 0.747',
							goTo: 'GENERAL5',
						},
					],
					BulletsIndividual: [
						{
							Position: '-5.474 -0.129 5.250',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SEL 4X2 FHEV',
						},
						{
							Position: '-2.708 -0.129 3.176',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SEL 4X2 FHEV DIG IZQ',
						},
						{
							Position: '-4.514 -0.129 -3.743',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SEL 4X2 FHEV POSTERIOR',
						},
						{
							Position: '1.549 -0.129 10.116',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV',
						},
					],
				},
				'ESCAPE SEL 4X2 FHEV POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/EscapeSEL_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '-17.838 -1.106 -18.674',
							Rotation: '-83.926 64.024 -64.151',
							Scale: '1.079 1.079',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-2.116 -0.129 -1.382',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE SEL 4X2 FHEV DIG DER',
						},
						{
							Position: '-5.552 -0.129 2.343',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE SEL 4X2 FHEV LAT IZQ',
						},
						{
							Position: '-5.552 -0.129 -2.680',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'ESCAPE SEL 4X2 FHEV LAT DER',
						},
						{
							Position: '-4.290 -0.129 -9.617',
							Rotation: '-90 0 0',
							Scale: '0.473 0.473',
							goTo: 'ESCAPE SE 4X2 FHEV',
						},
						{
							Position: '-14.288 -0.129 6.791',
							Rotation: '-83.622 114.538 -114.404',
							Scale: '0.473 0.473',
							goTo: 'ESCAPE TITANIUM 4X4 FHEV',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 -0.351 -0.001',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Apertura eléctrica de baúl con función de manos libres. No importa que tengas las manos ocupadas. Basta con pasar el pie por debajo de la defensa trasera para que la puerta del baúl se abra o se cierre por si sola. Es necesario tener la llave de acceso inteligente cerca.',
							Image: require('./../assets/Galerias/03_EscapeSEL4X2HEV/01_Bullets/Bullet 07.webp'),
						},
					],
				},

				'EXPEDITION LIMITED': {
					Image: require('./../assets/panoramas/Desktop/FordExpedition_Frente.webp'),
					Rotation: '0 90 0',
					Category: 'CAMIONETAS',
					Family: 'EXPEDITION',
					Bullets: [
						{
							Position: '9.701 -0.129 10.898',
							Rotation: '-90 180 0',
							Scale: '0.6 0.6',
							goTo: 'FAMILIA ESCAPE',
						},
						{
							Position: '-5.405 -0.129 -11.238',
							Rotation: '-90 180 0',
							Scale: '0.3 0.3',
							goTo: 'FAMILIA EDGE',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '8.849 -0.129 5.826',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
						{
							Position: '0.446 -0.129 -8.901',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL5',
						},
					],
					BulletsIndividual: [
						{
							Position: '-1.886 -0.129 -2.672',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'EXPEDITION LIMITED DIG IZQ',
						},
						{
							Position: '-5.688 -0.129 -3.729',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'EXPEDITION LIMITED LAT IZQ',
						},
						{
							Position: '-4.694 -0.129 3.676',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'EXPEDITION LIMITED LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.486 -1.278',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema de monitoreo de punto ciego BLIS y alerta de tráfico cruzado. Detecta cuando otro auto está en el carril contiguo dentro del punto ciego, avisando por medio de una luz en los espejos laterales. La alerta de tráfico cruzado transversal puede darte avisos y detecta vehículos cuando se está retrocediendo lentamente de un lugar de estacionamiento.',
							Image: require('./../assets/Galerias/12_ExpeditionLimited/01_Bullets/Bullet 07.webp'),
						},
						{
							Position: '-3.826 0.499 0.060',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema de iluminación con tecnología LED. Ya no hay que preocuparse por encender o apagar las luces, la Nueva Expedition posee faros delanteros LED, más eficientes, que se encienden o apagan automáticamente al controlarse mediante un sensor de luz. Así mismo la Nueva Expedition incorpora luces altas automáticas, con las cuales logras la visibilidad necesaria en carretera, sin incomodar a los demás conductores.',
							Image: require('./../assets/Galerias/12_ExpeditionLimited/01_Bullets/Bullet 06.webp'),
						},
					],
				},
				'EXPEDITION LIMITED DIG DER': {
					Image: require('./../assets/panoramas/Desktop/FordExpedition_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-3.705 -0.129 -2.697',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPEDITION LIMITED LAT DER',
						},
						{
							Position: '-3.326 -0.129 2.731',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPEDITION LIMITED POSTERIOR',
						},
					],
				},
				'EXPEDITION LIMITED DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/FordExpedition_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '1.796 -0.129 -11.946',
							Rotation: '-90 0 0',
							Scale: '0.5 0.5',
							goTo: 'FAMILIA EDGE',
						},
						{
							Position: '-2.303 -0.129 13.986',
							Rotation: '-90 0 0',
							Scale: '0.8 0.8',
							goTo: 'FAMILIA ESCAPE',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '6.422 -0.129 -4.694',
							Rotation: '-90 0 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL 5',
						},
						{
							Position: '6.422 -0.129 21.245',
							Rotation: '-90 0 0',
							Scale: '1 1',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-3.705 -0.129 -2.697',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPEDITION LIMITED LAT IZQ',
						},
						{
							Position: '-2.717 -0.129 2.046',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPEDITION LIMITED',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.486 -0.820',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema de monitoreo de punto ciego BLIS y alerta de tráfico cruzado. Detecta cuando otro auto está en el carril contiguo dentro del punto ciego, avisando por medio de una luz en los espejos laterales. La alerta de tráfico cruzado transversal puede darte avisos y detecta vehículos cuando se está retrocediendo lentamente de un lugar de estacionamiento.',
							Image: require('./../assets/Galerias/12_ExpeditionLimited/01_Bullets/Bullet 07.webp'),
						},
						{
							Position: '-3.826 0.443 -0.752',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Estribos con despliegue eléctrico. Los estribos de la Nueva Expedition se despliegan / repliegan automáticamente con solo abrir o cerrar las puertas.',
							Image: require('./../assets/Galerias/12_ExpeditionLimited/01_Bullets/Bullet 08.webp'),
						},
					],
				},
				'EXPEDITION LIMITED LAT DER': {
					Image: require('./../assets/panoramas/Desktop/FordExpedition_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.822 -0.129 -6.808',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'EXPEDITION LIMITED',
						},
						{
							Position: '-4.822 -0.129 5.441',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'EXPEDITION LIMITED POSTERIOR',
						},
						{
							Position: '-1.809 -0.129 2.969',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'EXPEDITION LIMITED DIG DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.486 -1.613',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema de monitoreo de punto ciego BLIS y alerta de tráfico cruzado. Detecta cuando otro auto está en el carril contiguo dentro del punto ciego, avisando por medio de una luz en los espejos laterales. La alerta de tráfico cruzado transversal puede darte avisos y detecta vehículos cuando se está retrocediendo lentamente de un lugar de estacionamiento.',
							Image: require('./../assets/Galerias/12_ExpeditionLimited/01_Bullets/Bullet 07.webp'),
						},
						{
							Position: '-3.826 0.235 -1.375',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Estribos con despliegue eléctrico. Los estribos de la Nueva Expedition se despliegan / repliegan automáticamente con solo abrir o cerrar las puertas.',
							Image: require('./../assets/Galerias/12_ExpeditionLimited/01_Bullets/Bullet 08.webp'),
						},
					],
				},
				'EXPEDITION LIMITED LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/FordExpedition_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '9.705 -0.129 -1.203',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA EDGE',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '4.510 -0.129 5.237',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL 5',
						},
					],
					BulletsIndividual: [
						{
							Position: '-4.514 -0.129 -3.743',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPEDITION LIMITED POSTERIOR',
						},
						{
							Position: '-2.146 -0.129 3.090',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPEDITION LIMITED DIG IZQ',
						},
						{
							Position: '-4.504 -0.129 5.316',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPEDITION LIMITED',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.486 1.613',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema de monitoreo de punto ciego BLIS y alerta de tráfico cruzado. Detecta cuando otro auto está en el carril contiguo dentro del punto ciego, avisando por medio de una luz en los espejos laterales. La alerta de tráfico cruzado transversal puede darte avisos y detecta vehículos cuando se está retrocediendo lentamente de un lugar de estacionamiento.',
							Image: require('./../assets/Galerias/12_ExpeditionLimited/01_Bullets/Bullet 07.webp'),
						},
						{
							Position: '-3.826 0.235 1.375',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Estribos con despliegue eléctrico. Los estribos de la Nueva Expedition se despliegan / repliegan automáticamente con solo abrir o cerrar las puertas.',
							Image: require('./../assets/Galerias/12_ExpeditionLimited/01_Bullets/Bullet 08.webp'),
						},
					],
				},
				'EXPEDITION LIMITED POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/FordExpedition_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.369 -0.129 -2.318',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPEDITION LIMITED DIG DER',
						},
						{
							Position: '-4.503 -0.129 -3.167',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPEDITION LIMITED LAT DER',
						},
						{
							Position: '-4.503 -0.129 3.241',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPEDITION LIMITED LAT IZQ',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 -0.725 -0.074',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Apertura eléctrica de baúl con función de manos libres. No importa que tengas las manos ocupadas. Basta con pasar el pie por debajo de la defensa trasera para que la puerta del baúl se abra o se cierre por si sola. Es necesario tener la llave de acceso inteligente cerca.',
							Image: require('./../assets/Galerias/12_ExpeditionLimited/01_Bullets/Bullet 09.webp'),
						},
					],
				},

				'EXPLORER LIMITED': {
					Image: require('./../assets/panoramas/Desktop/ExplorerLimited_Frente.webp'),
					Rotation: '0  90 0',
					Bullets: [
						{
							Position: '-2.075 -0.129 -9.830',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA EXPLORER',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '8.179 -0.129 -2.508',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL7',
						},
					],
					BulletsIndividual: [
						{
							Position: '-1.682 -0.129 -1.656',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPLORER LIMITED DIG IZQ',
						},
						{
							Position: '-5.384 -0.129 -2.614',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER LIMITED LAT IZQ',
						},
						{
							Position: '-5.374 -0.129 3.036',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER LIMITED LAT DER',
						},
						{
							Position: '-5.768 -0.129 -8.339',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER ST',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.258 0.075',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Limpiabrisas delantero con sensor de lluvia. Activa automáticamente los limpiaparabrisas cuando detecta humedad o presencia de agua en el parabrisas, aumentando y disminuyendo la velocidad de barrido según la intensidad de la lluvia. Disponible en la versión Limited.',
							Image: require('./../assets/Galerias/10_ExplorerLimited/01_Bullets/Bullet 09.webp'),
						},
						{
							Position: '-3.826 0.499 0.060',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema de rejillas activas. Se abren y cierran de forma automática para mejorar la aerodinámica y la eficiencia de consumo de combustible. ',
							Image: require('./../assets/Galerias/10_ExplorerLimited/01_Bullets/Bullet 06.webp'),
						},
					],
				},
				'EXPLORER LIMITED DIG DER': {
					Image: require('./../assets/panoramas/Desktop/ExplorerLimited_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-3.048 -0.129 1.757',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPLORER LIMITED POSTERIOR',
						},
						{
							Position: '-4.427 -0.129 -1.952',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPLORER LIMITED LAT DER',
						},
					],
				},
				'EXPLORER LIMITED DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/ExplorerLimited_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-2.589 -0.129 2.051',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER LIMITED',
						},
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER LIMITED LAT IZQ',
						},
						{
							Position: '-0.375 -0.129 -6.535',
							Rotation: '-90 146.081 -115.038',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER ST',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.307 -0.935',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Los espejos exteriores cuentan con sistema de abatimiento automático, calefacción y luces de entrada. Disponible en la versión Limited.',
							Image: require('./../assets/Galerias/10_ExplorerLimited/01_Bullets/espejos exteriores limited.webp'),
						},
						{
							Position: '-3.826 0.238 -0.178',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Los sensores del Sistema de Monitoreo de Presión de Neumáticos muestran la presión de aire de cada neumático. De esta manera conduces en óptimas condiciones, logrando mayor seguridad y eficiencia en el consumo de combustible.',
							Image: require('./../assets/Galerias/10_ExplorerLimited/01_Bullets/Bullet 07.webp'),
						},
					],
				},
				'EXPLORER LIMITED LAT DER': {
					Image: require('./../assets/panoramas/Desktop/ExplorerLimited_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '3.369 -0.129 -14.880',
							Rotation: '-95.000 180.000 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL7',
						},
					],
					BulletsIndividual: [
						{
							Position: '-4.608 -0.129 -4.605',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER LIMITED',
						},
						{
							Position: '-4.608 -0.129 4.016',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER LIMITED POSTERIOR',
						},
						{
							Position: '-2.883 -0.447 2.834',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER LIMITED DIG DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.098 -1.002',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Los espejos exteriores cuentan con sistema de abatimiento automático, calefacción y luces de entrada. Disponible en la versión Limited.',
							Image: require('./../assets/Galerias/10_ExplorerLimited/01_Bullets/espejos exteriores limited.webp'),
						},
						{
							Position: '-3.826 0.238 -1.972',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Los sensores del Sistema de Monitoreo de Presión de Neumáticos muestran la presión de aire de cada neumático. De esta manera conduces en óptimas condiciones, logrando mayor seguridad y eficiencia en el consumo de combustible.',
							Image: require('./../assets/Galerias/10_ExplorerLimited/01_Bullets/Bullet 07.webp'),
						},
					],
				},
				'EXPLORER LIMITED LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/ExplorerLimited_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-5.474 -0.129 5.250',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER LIMITED',
						},
						{
							Position: '-2.708 -0.129 3.176',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER LIMITED DIG IZQ',
						},
						{
							Position: '-4.514 -0.129 -3.743',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER LIMITED POSTERIOR',
						},
						{
							Position: '3.961 -0.129 -1.212',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER ST',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.153 0.873',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Los espejos exteriores cuentan con sistema de abatimiento automático, calefacción y luces de entrada. Disponible en la versión Limited.',
							Image: require('./../assets/Galerias/10_ExplorerLimited/01_Bullets/espejos exteriores limited.webp'),
						},
						{
							Position: '-3.826 0.238 1.972',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Los sensores del Sistema de Monitoreo de Presión de Neumáticos muestran la presión de aire de cada neumático. De esta manera conduces en óptimas condiciones, logrando mayor seguridad y eficiencia en el consumo de combustible.',
							Image: require('./../assets/Galerias/10_ExplorerLimited/01_Bullets/Bullet 07.webp'),
						},
					],
				},
				'EXPLORER LIMITED POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/ExplorerLimited_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-2.116 -0.129 -1.382',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPLORER LIMITED DIG DER',
						},
						{
							Position: '-5.552 -0.129 2.580',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPLORER LIMITED LAT IZQ',
						},
						{
							Position: '-5.552 -0.129 -2.680',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPLORER LIMITED LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 -0.529 -0.215',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Apertura eléctrica de baúl con función de manos libres. No importa que tengas las manos ocupadas. Basta con pasar el pie por debajo de la defensa trasera para que la puerta del baúl se abra o se cierre por si sola. Es necesario tener la llave de acceso inteligente cerca. Disponible en la versión Limited.',
							Image: require('./../assets/Galerias/10_ExplorerLimited/01_Bullets/Bullet 08.webp'),
						},
					],
				},

				'EXPLORER ST': {
					Image: require('./../assets/panoramas/Desktop/ExplorerST_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '3.201 -0.129 0.304',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA EXPLORER',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '8.849 -0.129 5.826',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL7',
						},
					],
					BulletsIndividual: [
						{
							Position: '-1.682 -0.129 -1.656',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPLORER ST DIG IZQ',
						},
						{
							Position: '-5.384 -0.129 -2.614',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER ST LAT IZQ',
						},
						{
							Position: '-5.374 -0.129 3.036',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER ST LAT DER',
						},
						{
							Position: '-5.768 -0.129 -8.339',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER XLT',
						},
						{
							Position: '3.383 -0.129 8.555',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER LIMITED',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.499 0.060',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Ya no hay que preocuparse por encender o apagar las luces, la Nueva Explorer ST posee faros delanteros LED, más eficientes, y que se encienden o apagan automáticamente al controlarse mediante un sensor de luz. Así mismo la Nueva Explorer ST incorpora luces altas automáticas, con las cuales logras la visibilidad necesaria en carretera, sin incomodar a los demás conductores.',
							Image: require('./../assets/Galerias/11_ExplorerST/01_Bullets/Bullet 06.webp'),
						},
					],
				},
				'EXPLORER ST DIG DER': {
					Image: require('./../assets/panoramas/Desktop/ExplorerST_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-3.048 -0.129 1.757',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPLORER ST POSTERIOR',
						},
						{
							Position: '-4.427 -0.129 -1.952',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPLORER ST LAT DER',
						},
					],
				},
				'EXPLORER ST DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/ExplorerST_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '0.443 -0.129 3.898',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA EXPLORER',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-2.589 -0.129 2.051',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER ST',
						},
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER ST LAT IZQ',
						},
						{
							Position: '-0.375 -0.129 -6.535',
							Rotation: '-90 146.081 -115.038',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER XLT',
						},
						{
							Position: '-4.533 -0.129 11.110',
							Rotation: '-90 146.081 -115.038',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER LIMITED',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.307 -0.935',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Los espejos exteriores cuentan con sistema de abatimiento automático, calefacción y luces de entrada. *Imágenes de referencia que no corresponden a la Explorer ST comercializada en Colombia.',
							Image: require('./../assets/Galerias/11_ExplorerST/01_Bullets/espejos exterior st.webp'),
						},
					],
				},
				'EXPLORER ST LAT DER': {
					Image: require('./../assets/panoramas/Desktop/ExplorerST_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '-5.364 -0.129 -10.878',
							Rotation: '-90 0 0',
							Scale: '0.55 0.55',
							goTo: 'FAMILIA EXPLORER',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.608 -0.129 -4.605',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER ST',
						},
						{
							Position: '-4.608 -0.129 4.016',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER ST POSTERIOR',
						},
						{
							Position: '-2.883 -0.447 2.834',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER ST DIG DER',
						},

						{
							Position: '4.092 -0.129 -9.554',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER LIMITED',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.204 -1.829',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Frenos de alto desempeño. Se requieren de frenos contundentes para lograr controlar todo el poder de la Nueva Explorer ST. El vehículo cuenta con un sistema de frenos de alto desempeño con rotores y pastillas más grandes, junto con pistones de acero inoxidable. Además, las mordazas vienen en color rojo, lo que eleva su caracter deportivo.',
							Image: require('./../assets/Galerias/11_ExplorerST/01_Bullets/Bullet 09.webp'),
						},
						{
							Position: '-3.826 0.119 1.641',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Los sensores del Sistema de Monitoreo de Presión de Neumáticos muestran la presión de aire de cada neumático. De esta manera conduces en óptimas condiciones, logrando mayor seguridad y eficiencia en el consumo de combustible.',
							Image: require('./../assets/Galerias/11_ExplorerST/01_Bullets/Bullet 07.webp'),
						},
						{
							Position: '-3.826 1.168 -0.789',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Los espejos exteriores cuentan con sistema de abatimiento automático, calefacción y luces de entrada. *Imágenes de referencia que no corresponden a la Explorer ST comercializada en Colombia.',
							Image: require('./../assets/Galerias/11_ExplorerST/01_Bullets/espejos exterior st.webp'),
						},
					],
				},
				'EXPLORER ST LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/ExplorerST_LateralIzq.webp'),
					Rotation: '0 70 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-5.474 -0.129 5.250',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER ST',
						},
						{
							Position: '-2.708 -0.129 3.176',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER ST DIG IZQ',
						},
						{
							Position: '-4.514 -0.129 -3.743',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER ST POSTERIOR',
						},
						{
							Position: '3.961 -0.129 -1.212',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER XLT',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.168 0.789',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Los espejos exteriores cuentan con sistema de abatimiento automático, calefacción y luces de entrada. *Imágenes de referencia que no corresponden a la Explorer ST comercializada en Colombia.',
							Image: require('./../assets/Galerias/11_ExplorerST/01_Bullets/espejos exterior st.webp'),
						},
						{
							Position: '-3.826 0.164 1.900',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Frenos de alto desempeño. Se requieren de frenos contundentes para lograr controlar todo el poder de la Nueva Explorer ST. El vehículo cuenta con un sistema de frenos de alto desempeño con rotores y pastillas más grandes, junto con pistones de acero inoxidable. Además, las mordazas vienen en color rojo, lo que eleva su caracter deportivo.',
							Image: require('./../assets/Galerias/11_ExplorerST/01_Bullets/Bullet 09.webp'),
						},
						{
							Position: '-3.826 0.174 -1.512',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Los sensores del Sistema de Monitoreo de Presión de Neumáticos muestran la presión de aire de cada neumático. De esta manera conduces en óptimas condiciones, logrando mayor seguridad y eficiencia en el consumo de combustible.',
							Image: require('./../assets/Galerias/11_ExplorerST/01_Bullets/Bullet 07.webp'),
						},
					],
				},
				'EXPLORER ST POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/ExplorerST_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-2.116 -0.129 -1.382',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPLORER ST DIG DER',
						},
						{
							Position: '-5.552 -0.129 2.580',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPLORER ST LAT IZQ',
						},
						{
							Position: '-5.552 -0.129 -2.680',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPLORER ST LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 -0.529 -0.215',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Apertura eléctrica de baúl con función de manos libres. No importa que tengas las manos ocupadas. Basta con pasar el pie por debajo de la defensa trasera para que la puerta del baúl se abra o se cierre por si sola. Es necesario tener la llave de acceso inteligente cerca. Disponible en la versión Limited.',
							Image: require('./../assets/Galerias/11_ExplorerST/01_Bullets/Bullet 08.webp'),
						},
					],
				},

				'EXPLORER XLT': {
					Image: require('./../assets/panoramas/Desktop/ExplorerXLT_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '6.575 -0.129 4.268',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA EXPLORER',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.682 -0.129 -1.656',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPLORER XLT DIG IZQ',
						},
						{
							Position: '-5.384 -0.129 -2.614',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER XLT LAT IZQ',
						},
						{
							Position: '-5.374 -0.129 3.036',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER XLT LAT DER',
						},
						{
							Position: '3.676 -0.129 8.726',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER ST',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.307 -0.935',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Detecta cuando otro vehículo está en el carril contiguo dentro del punto ciego de la Nueva Explorer, alertándote por medio de una luz en los espejos laterales. Este sistema también detecta el punto ciego de un tráiler, en caso de venir remolcando uno. La alerta de tráfico cruzado detecta vehículos cuando se está retrocediendo lentamente, ideal al salir de un estacionamiento.',
							Image: require('./../assets/Galerias/09_ExplorerXLT/01_Bullets/Bullet 09.webp'),
						},
						{
							Position: '-3.826 0.534 -0.417',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Las rejillas activas se abren y cierran de forma automática para mejorar la aerodinámica y la eficiencia de consumo de combustible.',
							Image: require('./../assets/Galerias/09_ExplorerXLT/01_Bullets/parrilla explorer xlt.webp'),
						},
					],
				},
				'EXPLORER XLT DIG DER': {
					Image: require('./../assets/panoramas/Desktop/ExplorerXLT_DiagonalDer.webp'),
					Rotation: '0 -90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-3.048 -0.129 1.757',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPLORER XLT POSTERIOR',
						},
						{
							Position: '-4.427 -0.129 -1.952',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPLORER XLT LAT DER',
						},
					],
				},
				'EXPLORER XLT DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/ExplorerXLT_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-2.589 -0.129 2.051',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER XLT',
						},
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER XLT LAT IZQ',
						},
						{
							Position: '-4.319 -0.129 10.571',
							Rotation: '-85.712 146.081 -115.038',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER ST',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.307 -0.935',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Detecta cuando otro vehículo está en el carril contiguo dentro del punto ciego de la Nueva Explorer, alertándote por medio de una luz en los espejos laterales. Este sistema también detecta el punto ciego de un tráiler, en caso de venir remolcando uno. La alerta de tráfico cruzado detecta vehículos cuando se está retrocediendo lentamente, ideal al salir de un estacionamiento.',
							Image: require('./../assets/Galerias/09_ExplorerXLT/01_Bullets/Bullet 09.webp'),
						},
					],
				},
				'EXPLORER XLT LAT DER': {
					Image: require('./../assets/panoramas/Desktop/ExplorerXLT_LateralDer.webp'),
					Rotation: '0 -70 0',
					Bullets: [
						{
							Position: '1.857 -0.129 -13.379',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'FAMILIA EXPLORER',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.608 -0.129 -4.605',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER XLT',
						},
						{
							Position: '-4.608 -0.129 4.016',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER XLT POSTERIOR',
						},
						{
							Position: '-2.883 -0.447 2.834',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER XLT DIG DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.246 -0.903',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Detecta cuando otro vehículo está en el carril contiguo dentro del punto ciego de la Nueva Explorer, alertándote por medio de una luz en los espejos laterales. Este sistema también detecta el punto ciego de un tráiler, en caso de venir remolcando uno. La alerta de tráfico cruzado detecta vehículos cuando se está retrocediendo lentamente, ideal al salir de un estacionamiento.',
							Image: require('./../assets/Galerias/09_ExplorerXLT/01_Bullets/Bullet 09.webp'),
						},
						{
							Position: '-3.826 0.119 1.641',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Después de casi 9 años, la Nueva Explorer retoma la éxitosa fórmula de tracción trasera. Su nueva plataforma modular de tracción trasera no solo mejora notablemente las capacidades y dinámicas de manejo, el espacio para pasajeros y carga, sino que también hace posible la incorporación de nuevas tecnologías de seguridad activa.',
							Image: require('./../assets/Galerias/09_ExplorerXLT/01_Bullets/Bullet 08.webp'),
						},
					],
				},
				'EXPLORER XLT LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/ExplorerXLT_LateralIzq.webp'),
					Rotation: '0 70 0',
					Bullets: [
						{
							Position: '-8.272 -0.129 9.052',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA EXPLORER',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-5.474 -0.129 5.250',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER XLT',
						},
						{
							Position: '-2.708 -0.129 3.176',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER XLT DIG IZQ',
						},
						{
							Position: '-4.514 -0.129 -3.743',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EXPLORER XLT POSTERIOR',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.253 0.920',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Detecta cuando otro vehículo está en el carril contiguo dentro del punto ciego de la Nueva Explorer, alertándote por medio de una luz en los espejos laterales. Este sistema también detecta el punto ciego de un tráiler, en caso de venir remolcando uno. La alerta de tráfico cruzado detecta vehículos cuando se está retrocediendo lentamente, ideal al salir de un estacionamiento.',
							Image: require('./../assets/Galerias/09_ExplorerXLT/01_Bullets/Bullet 09.webp'),
						},
						{
							Position: '-3.826 0.119 -1.594',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Después de casi 9 años, la Nueva Explorer retoma la éxitosa fórmula de tracción trasera. Su nueva plataforma modular de tracción trasera no solo mejora notablemente las capacidades y dinámicas de manejo, el espacio para pasajeros y carga, sino que también hace posible la incorporación de nuevas tecnologías de seguridad activa.',
							Image: require('./../assets/Galerias/09_ExplorerXLT/01_Bullets/Bullet 08.webp'),
						},
					],
				},
				'EXPLORER XLT POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/ExplorerXLT_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-2.116 -0.129 -1.382',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPLORER XLT DIG DER',
						},
						{
							Position: '-5.552 -0.129 2.580',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPLORER XLT LAT IZQ',
						},
						{
							Position: '-5.552 -0.129 -2.680',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EXPLORER XLT LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.061 -1.254',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Nueva Explorer se convierte en la Explorer más poderosa de la historia en Colombia. Integra un potente motor turbo 2.3L EcoBoost, capaz de desarrollar impresionantes 300 hp y 420 Nm de torque. Este propulsor es uno de los 10 motores de 4 cilindros en línea más poderosos del mundo.',
							Image: require('./../assets/Galerias/09_ExplorerXLT/01_Bullets/Bullet 06.webp'),
						},
					],
				},

				'F-150 LARIAT SPORT': {
					Image: require('./../assets/panoramas/Desktop/F-150Lariat_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '6.575 -0.129 4.268',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA F150',
						},
						{
							Position: '4.348 -0.129 -17.319',
							Rotation: '-85.000 -19.014 180.000',
							Scale: '0.8 0.8',
							goTo: 'FAMILIA ESCAPE',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '6.268 -0.129 -4.817',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
						{
							Position: '11.577 -0.129 3.116',
							Rotation: '-90 0 0',
							Scale: '0.448 0.448',
							goTo: 'GENERAL3',
						},
						{
							Position: '19.197 -0.129 15.216',
							Rotation: '-90 0 0',
							Scale: '0.74 0.74',
							goTo: 'GENERAL2',
						},
					],
					BulletsIndividual: [
						{
							Position: '-1.886 -0.129 -2.672',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 LARIAT SPORT DIG IZQ',
						},
						{
							Position: '-4.695 -0.119 4.104',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 LARIAT SPORT LAT DER',
						},
						{
							Position: '-6.366 -0.119 -4.674',
							Rotation: '-90 180 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 LARIAT SPORT LAT IZQ',
						},
						{
							Position: '5.2735 -0.129 7.707',
							Rotation: '-90 180 0',
							Scale: '0.5 0.5',
							goTo: 'F-150 RAPTOR',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.499 -2.058',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Nuevo diseño de faros delanteros con proyector LED. Incluye las Exploradoras con Función de Cornering Lamps que se adaptan al movimiento del vehículo para mejorar la visibilidad en las esquinas, especialmente en los días con neblina.',
							Image: require('./../assets/Galerias/21_F150Latiat-Sport/01_Bullets/Bullet 06.webp'),
						},
						{
							Position: '-3.826 1.483 -1.502',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Totalmente Nueva Ford F-150 incorpora nuevo diseño de espejos exteriores eléctricos con tecnología de punta. Los espejos exteriores cuentan con sistema de abatimiento automático, calefacción, luces de aproximación, luces LED adicionales para iluminación exterior y memoria. Particularmente, el espejo exterior del lado del conductor es electrocrómico. Disponibles en las versiones la F-150 Lariat Sport y la F-150 XLT',
							Image: require('./../assets/Galerias/21_F150Latiat-Sport/01_Bullets/Bullet 10.webp'),
						},
					],
				},
				'F-150 LARIAT SPORT DIG DER': {
					Image: require('./../assets/panoramas/Desktop/F-150Lariat_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.573 -0.129 1.757',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 LARIAT SPORT POSTERIOR',
						},
						{
							Position: '-3.705 -0.129 -2.697',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 LARIAT SPORT LAT DER',
						},
					],
				},
				'F-150 LARIAT SPORT DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/F-150Lariat_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '-1.713 -0.129 11.804',
							Rotation: '-90 0 0',
							Scale: '0.466 0.466',
							goTo: 'FAMILIA F150',
						},
						{
							Position: '19.975 -2.308 -16.809',
							Rotation: '-85.348 -51.003 89.476',
							Scale: '0.6 0.6',
							goTo: 'FAMILIA ESCAPE',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '2.275 -0.129 11.974',
							Rotation: '-90 0 0',
							Scale: '0.46 0.46',
							goTo: 'GENERAL3',
						},
						{
							Position: '-0.780 -0.129 29.231',
							Rotation: '-90 0 0',
							Scale: '0.8 0.8',
							goTo: 'GENERAL2',
						},
						{
							Position: '4.793 -0.129 0.445',
							Rotation: '-85.712 146.08 -115.038',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-2.589 -0.129 2.051',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 LARIAT SPORT',
						},
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 LARIAT SPORT LAT IZQ',
						},
						{
							Position: '-11.157 -0.129 5.701',
							Rotation: '-85.712 146.081 -115.038',
							Scale: '0.4 0.4',
							goTo: 'ESCAPE SE 4X2 FHEV',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.814 -0.831',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'No necesitas tener la llave contigo para ingresar a la Nueva F-150. Con solo digitar el código personalizado en el teclado digital externo podrás hacerlo.',
							Image: require('./../assets/Galerias/21_F150Latiat-Sport/01_Bullets/Bullet 08.webp'),
						},
						{
							Position: '-3.826 1.280 -0.604',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Totalmente Nueva Ford F-150 incorpora nuevo diseño de espejos exteriores eléctricos con tecnología de punta. Los espejos exteriores cuentan con sistema de abatimiento automático, calefacción, luces de aproximación, luces LED adicionales para iluminación exterior y memoria. Particularmente, el espejo exterior del lado del conductor es electrocrómico. Disponibles en las versiones la F-150 Lariat Sport y la F-150 XLT',
							Image: require('./../assets/Galerias/21_F150Latiat-Sport/01_Bullets/Bullet 10.webp'),
						},
					],
				},
				'F-150 LARIAT SPORT LAT DER': {
					Image: require('./../assets/panoramas/Desktop/F-150Lariat_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.822 -0.129 -6.808',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'F-150 LARIAT SPORT',
						},
						{
							Position: '2.095 -0.129 -10.012',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'F-150 RAPTOR',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.814 -0.806',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'No necesitas tener la llave contigo para ingresar a la Nueva F-150. Con solo digitar el código personalizado en el teclado digital externo podrás hacerlo.',
							Image: require('./../assets/Galerias/21_F150Latiat-Sport/01_Bullets/Bullet 08.webp'),
						},
						{
							Position: '-3.826 1.280 -2.276',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Totalmente Nueva Ford F-150 incorpora nuevo diseño de espejos exteriores eléctricos con tecnología de punta. Los espejos exteriores cuentan con sistema de abatimiento automático, calefacción, luces de aproximación, luces LED adicionales para iluminación exterior y memoria. Particularmente, el espejo exterior del lado del conductor es electrocrómico. Disponibles en las versiones la F-150 Lariat Sport y la F-150 XLT',
							Image: require('./../assets/Galerias/21_F150Latiat-Sport/01_Bullets/Bullet 10.webp'),
						},
						{
							Position: '-3.826 0.182 -1.421',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Totalmente Nueva Ford F-150 incorpora nuevos estribos laterales extendidos. Ahora más largos para obtener una mejor posición y lograr acceder a la cabina o al platón, desde la parte lateral de la pick up, de una manera más fácil. ',
							Image: require('./../assets/Galerias/21_F150Latiat-Sport/01_Bullets/Bullet 09.webp'),
						},
					],
				},
				'F-150 LARIAT SPORT LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/F-150Lariat_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '13.240 -0.129 6.069',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA ESCAPE',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '1.549 -0.129 10.116',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'START',
						},
					],
					BulletsIndividual: [
						{
							Position: '-5.474 -0.129 6.279',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 LARIAT SPORT',
						},
						{
							Position: '-2.708 -0.129 3.176',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 LARIAT SPORT DIG IZQ',
						},
						{
							Position: '-4.514 -0.129 -3.743',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 LARIAT SPORT POSTERIOR',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.814 0.806',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'No necesitas tener la llave contigo para ingresar a la Nueva F-150. Con solo digitar el código personalizado en el teclado digital externo podrás hacerlo.',
							Image: require('./../assets/Galerias/21_F150Latiat-Sport/01_Bullets/Bullet 08.webp'),
						},
						{
							Position: '-3.826 1.280 2.276',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Totalmente Nueva Ford F-150 incorpora nuevo diseño de espejos exteriores eléctricos con tecnología de punta. Los espejos exteriores cuentan con sistema de abatimiento automático, calefacción, luces de aproximación, luces LED adicionales para iluminación exterior y memoria. Particularmente, el espejo exterior del lado del conductor es electrocrómico. Disponibles en las versiones la F-150 Lariat Sport y la F-150 XLT',
							Image: require('./../assets/Galerias/21_F150Latiat-Sport/01_Bullets/Bullet 10.webp'),
						},
						{
							Position: '-3.826 0.182 1.421',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Totalmente Nueva Ford F-150 incorpora nuevos estribos laterales extendidos. Ahora más largos para obtener una mejor posición y lograr acceder a la cabina o al platón, desde la parte lateral de la pick up, de una manera más fácil. ',
							Image: require('./../assets/Galerias/21_F150Latiat-Sport/01_Bullets/Bullet 09.webp'),
						},
					],
				},
				'F-150 LARIAT SPORT POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/F-150Lariat_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '-8.598 -0.129 15.218',
							Rotation: '-87.416 180.000 180.000',
							Scale: '0.681 0.681',
							goTo: 'FAMILIA ESCAPE',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.369 -0.129 -2.318',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 LARIAT SPORT DIG DER',
						},
						{
							Position: '-5.552 -0.129 3.637',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 LARIAT SPORT LAT IZQ',
						},
						{
							Position: '-5.552 -0.129 -3.749',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 LARIAT SPORT LAT DER',
						},
					],
				},

				'F-150 XLT FHEV': {
					Image: require('./../assets/panoramas/Desktop/F-150XLT_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '2.113 -0.129 -6.187',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA F150',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '7.580 -0.129 -9.496',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL3',
						},
					],
					BulletsIndividual: [
						{
							Position: '-1.682 -0.129 -1.656',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 XLT FHEV DIG IZQ',
						},
						{
							Position: '-5.384 -0.129 -3.814',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 XLT FHEV LAT IZQ',
						},
						{
							Position: '-5.374 -0.129 3.836',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 XLT FHEV LAT DER',
						},
						{
							Position: '-2.529 -0.129 -7.045',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 RAPTOR',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.170 -0.714',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Completamente Híbrida La Nueva F-150 Completamente Híbrida se caracteriza por su novedoso tren motriz PowerBoost™ que combina un motor a combustión EcoBoost V6 de 3.5L y un motor eléctrico de 44 caballos de fuerza con una batería de iones de litio de alto voltaje con capacidad de 1.5 KWh; lo que les permitirá a los usuarios colombianos, promover un estilo de vida más sustentable, contribuyendo con el cuidado del medio ambiente.',
							Image: require('./../assets/Galerias/F150XLT/Bullet/10.webp'),
						},
						{
							Position: '-3.826 0.170 0.695',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La F-150 Completamente Híbrida está modificando el entorno híbrido con desempeño potente y eficiente que se combina con su legendaria capacidad. Con su novedoso Tren Motriz PowerBoost™, sistema que se compone de dos motores, uno gasolina EcoBoost® 3.5L V6 y otro eléctrico, que combinados ofrecen una potencia máxima de 430 hp y 772 Nm.',
							Image: require('./../assets/Galerias/F150XLT/Bullet/11.webp'),
						},
					],
				},
				'F-150 XLT FHEV DIG DER': {
					Image: require('./../assets/panoramas/Desktop/F-150XLT_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-3.048 -0.129 1.757',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 XLT FHEV POSTERIOR',
						},
						{
							Position: '-4.427 -0.129 -1.952',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 XLT FHEV LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.252 -0.336',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Diseño de Rines. La Ford F-150 XLT Completamente Híbrida incorpora nuevo diseño de rines de 17" en aluminio. Este es uno de los más apropiado para todos esos clientes que quieran usar la camioneta en terrenos Off-Road.',
							Image: require('./../assets/Galerias/F150XLT/Bullet/8.webp'),
						},
					],
				},
				'F-150 XLT FHEV DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/F-150XLT_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '0.443 -0.129 3.898',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA F150',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-2.589 -0.129 2.051',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 XLT FHEV',
						},
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 XLT FHEV LAT IZQ',
						},
						{
							Position: '7.113 -0.129 -1.314',
							Rotation: '-90 146.081 -115.038',
							Scale: '0.4 0.4',
							goTo: 'F-150 RAPTOR',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.081 0.123',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Diseño de Rines. La Ford F-150 XLT Completamente Híbrida incorpora nuevo diseño de rines de 17" en aluminio. Este es uno de los más apropiado para todos esos clientes que quieran usar la camioneta en terrenos Off-Road.',
							Image: require('./../assets/Galerias/F150XLT/Bullet/8.webp'),
						},
					],
				},
				'F-150 XLT FHEV LAT DER': {
					Image: require('./../assets/panoramas/Desktop/F-150XLT_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '3.369 -0.129 -14.880',
							Rotation: '-95.000 180.000 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL2',
						},
					],
					BulletsIndividual: [
						{
							Position: '-4.608 -0.129 -5.602',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 XLT FHEV',
						},
						{
							Position: '-4.608 -0.129 4.016',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 XLT FHEV POSTERIOR',
						},
						{
							Position: '-2.883 -0.447 2.834',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 XLT FHEV DIG DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.199 -3.003',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Diseño de Rines. La Ford F-150 XLT Completamente Híbrida incorpora nuevo diseño de rines de 17" en aluminio. Este es uno de los más apropiado para todos esos clientes que quieran usar la camioneta en terrenos Off-Road.',
							Image: require('./../assets/Galerias/F150XLT/Bullet/8.webp'),
						},
					],
				},
				'F-150 XLT FHEV LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/F-150XLT_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-5.185 -0.129 5.757',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 XLT FHEV',
						},
						{
							Position: '-2.708 -0.129 3.176',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 XLT FHEV DIG IZQ',
						},
						{
							Position: '-4.514 -0.129 -3.743',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 XLT FHEV POSTERIOR',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.170 2.986',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Diseño de Rines. La Ford F-150 XLT Completamente Híbrida incorpora nuevo diseño de rines de 17" en aluminio. Este es uno de los más apropiado para todos esos clientes que quieran usar la camioneta en terrenos Off-Road.',
							Image: require('./../assets/Galerias/F150XLT/Bullet/8.webp'),
						},
					],
				},
				'F-150 XLT FHEV POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/F-150XLT_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.369 -0.129 -2.318',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 XLT FHEV DIG DER',
						},
						{
							Position: '-5.552 -0.129 3.637',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 XLT FHEV LAT IZQ',
						},
						{
							Position: '-5.552 -0.129 -3.749',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 XLT FHEV LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.182 1.547',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Escalón Integrado con Elevación Asistida La Nueva Ford F-150 XLT Completamente Híbrida equipa un escalón integrado con elevación asistida que hará mucho más fácil el ingreso al plantón de la camioneta.',
							Image: require('./../assets/Galerias/F150XLT/Bullet/7.webp'),
						},
						{
							Position: '-3.826 0.182 -1.547',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Pro Power Onboard™ La F-150 XLT Completamente Híbrida cuenta con la novedosa tecnología Pro Power Onboard™, un generador de energía exportable a lugares remotos, de trabajo y de la vida cotidiana, con una salida de 7.2 kW*, que se puede utilizar con los 6 tomacorrientes de 120V y 240V que contiene entre el platón y cabina, fácilmente controlable desde la pantalla táctil. *La potencia máxima disponible se limita al total combinado de todos los artículos en uso. La potencia también puede limitarse en el modo de manejo o en ciertas condiciones de temperatura ambiental. Algunos equipos eléctricos requieren más potencia de arranque que la tasa de funcionamiento y puede superar la capacidad de la potencia del sistema. Consulta el manual del propietario para obtener importantes indicaciones operativas.',
							Image: require('./../assets/Galerias/F150XLT/Bullet/9.webp'),
						},
						{
							Position: '-3.826 1.327 -0.054',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Camara 360° La cámara de 360° con pantalla dividida usa cuatro cámaras: una en la parrilla, una en la puerta trasera y una debajo de cada uno de los espejos laterales. El sistema te permite ver todos los lados de la camioneta ya que las imágenes se unen y se muestran en la pantalla de la consola central. Es útil cuando maniobras en espacios reducidos y en senderos. También es útil la característica de asistencia para enganche de remolque que te brinda una visión dinámica para ayudarte a enganchar la bola de enganche al remolque.',
							Image: require('./../assets/Galerias/F150XLT/Bullet/14.webp'),
						},
						{
							Position: '-3.826 0.182 -0.009',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'SUPERFICIE DE TRABAJO INTERIOR EN COMPUERTA TRASERA La Ford F-150 Completamente Híbrida fue pensada para optimizar todo el espacio disponible del vehículo. La nueva superficie interior de la compuerta trasera viene preparada para ejecutar funciones de trabajo como escribir sobre ella, medir y cortar. Incluye espacios dedicados para el soporte de dispositivos móviles, porta vasos, así como reglas para medir objetos y amarres que funcionan como abrebotellas',
							Image: require('./../assets/Galerias/F150XLT/Bullet/15.webp'),
						},
					],
				},


				'F-150 PLATINUM FHEV': {
					Image: require('./../assets/panoramas/Desktop/F-150PlatinumHEV_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '2.113 -0.129 -6.187',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA F150',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '7.580 -0.129 -9.496',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL3',
						},
					],
					BulletsIndividual: [
						{
							Position: '-1.682 -0.129 -1.656',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 PLATINUM FHEV DIG IZQ',
						},
						{
							Position: '-5.384 -0.129 -3.814',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 PLATINUM FHEV LAT IZQ',
						},
						{
							Position: '-5.374 -0.129 3.836',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 PLATINUM FHEV LAT DER',
						},
						{
							Position: '-2.529 -0.129 -7.045',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 RAPTOR',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.170 -1.966',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Con grupo de luces frontales LED La Ford F-150 Platinum Completamente Híbrida proporciona una iluminación brillante, eficiente y duradera. En la carretera, los faros delanteros con proyector LED disponibles con Giro Dinámico Adaptativo, se ajustan para obtener claridad alrededor de las curvas, creando una iluminación dinámica para ayudar al conductor a ver hacia los lados. También incluye las Exploradoras con función de Cornering Lamps, las cuales se adaptan al movimiento del vehículo para mejorar la visibilidad en las esquinas, especialmente en los días con neblina.',
							Image: require('./../assets/Galerias/F150PlatinumFHEV/Bullet/5.webp'),
						},
						{
							Position: '-3.826 0.170 0.695',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La F-150 Completamente Híbrida está modificando el entorno híbrido con desempeño potente y eficiente que se combina con su legendaria capacidad. Con su novedoso Tren Motriz PowerBoost™, sistema que se compone de dos motores, uno gasolina EcoBoost® 3.5L V6 y otro eléctrico, que combinados ofrecen una potencia máxima de 430 hp y 772 Nm',
							Image: require('./../assets/Galerias/F150PlatinumFHEV/Bullet/6.webp'),
						},
					],
				},
				'F-150 PLATINUM FHEV DIG DER': {
					Image: require('./../assets/panoramas/Desktop/F-150PlatinumHEV_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-3.048 -0.129 1.757',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 PLATINUM FHEV POSTERIOR',
						},
						{
							Position: '-4.427 -0.129 -1.952',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 PLATINUM FHEV LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.683 -1.168',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Estribos con despliegue eléctrico La Ford F-150 Platinum Completamente Híbrida, equipa nuevos estribos eléctricos extendidos, que se despliegan y retraen automáticamente, se guardan debajo del chasis y quedan fuera de la vista hasta que se necesiten. Además, se activan automáticamente cuando se abre la puerta y se retraen cuando se cierra. Si el conductor tiene las manos ocupadas, puede usar el nuevo botón de pie ubicado en la parte inferior del estribo para desplegarlo.',
							Image: require('./../assets/Galerias/F150PlatinumFHEV/Bullet/10.webp'),
						},
					],
				},
				'F-150 PLATINUM FHEV DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/F-150PlatinumHEV_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '0.443 -0.129 3.898',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA F150',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-2.589 -0.129 2.051',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 PLATINUM FHEV',
						},
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 PLATINUM FHEV LAT IZQ',
						},
						{
							Position: '7.113 -0.129 -1.314',
							Rotation: '-90 146.081 -115.038',
							Scale: '0.4 0.4',
							goTo: 'F-150 RAPTOR',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.538 -1.028',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Estribos con despliegue eléctrico La Ford F-150 Platinum Completamente Híbrida, equipa nuevos estribos eléctricos extendidos, que se despliegan y retraen automáticamente, se guardan debajo del chasis y quedan fuera de la vista hasta que se necesiten. Además, se activan automáticamente cuando se abre la puerta y se retraen cuando se cierra. Si el conductor tiene las manos ocupadas, puede usar el nuevo botón de pie ubicado en la parte inferior del estribo para desplegarlo.',
							Image: require('./../assets/Galerias/F150PlatinumFHEV/Bullet/10.webp'),
						},
						{
							Position: '-3.826 0.636 -0.570',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'FUNCIONAMIENTO MOTORIZACIÓN HÍBRIDA La F-150 Completamente Híbrida tiene dos motores: uno de combustión interna y otro eléctrico alimentado por una batería de alto voltaje de 1.5KWh. El sistema utiliza el motor eléctrico o ambos motores de acuerdo a la solicitud o demanda de potencia por parte del conductor. El cambio de modo eléctrico a híbrido se produce de manera automática e imperceptible para ofrecer la combinación perfecta de potencia y eficiencia. La batería de alto voltaje de 1.5KWh, se recarga durante el andar y almacena energía a través de dos sistemas: un generador eléctrico, que se encarga de transformar la energía mecánica proveniente del motor de combustión interna en energía eléctrica, y el Sistema de Frenado Regenerativo, que aprovecha hasta el 90% de la energía que se disipa durante el frenado para recargar la batería de alto voltaje',
							Image: require('./../assets/Galerias/F150PlatinumFHEV/Bullet/7.webp'),
						},
					],
				},
				'F-150 PLATINUM FHEV LAT DER': {
					Image: require('./../assets/panoramas/Desktop/F-150PlatinumHEV_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '3.369 -0.129 -14.880',
							Rotation: '-95.000 180.000 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL2',
						},
					],
					BulletsIndividual: [
						{
							Position: '-4.608 -0.129 -5.602',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 PLATINUM FHEV',
						},
						{
							Position: '-4.608 -0.129 4.016',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 PLATINUM FHEV POSTERIOR',
						},
						{
							Position: '-2.883 -0.447 2.834',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 PLATINUM FHEV DIG DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.199 -1.199',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Estribos con despliegue eléctrico La Ford F-150 Platinum Completamente Híbrida, equipa nuevos estribos eléctricos extendidos, que se despliegan y retraen automáticamente, se guardan debajo del chasis y quedan fuera de la vista hasta que se necesiten. Además, se activan automáticamente cuando se abre la puerta y se retraen cuando se cierra. Si el conductor tiene las manos ocupadas, puede usar el nuevo botón de pie ubicado en la parte inferior del estribo para desplegarlo.',
							Image: require('./../assets/Galerias/F150PlatinumFHEV/Bullet/10.webp'),
						},
					],
				},
				'F-150 PLATINUM FHEV LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/F-150PlatinumHEV_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-5.185 -0.129 5.757',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 PLATINUM FHEV',
						},
						{
							Position: '-2.708 -0.129 3.176',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 PLATINUM FHEV DIG IZQ',
						},
						{
							Position: '-4.514 -0.129 -3.743',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 PLATINUM FHEV POSTERIOR',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.170 1.196',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Estribos con despliegue eléctrico La Ford F-150 Platinum Completamente Híbrida, equipa nuevos estribos eléctricos extendidos, que se despliegan y retraen automáticamente, se guardan debajo del chasis y quedan fuera de la vista hasta que se necesiten. Además, se activan automáticamente cuando se abre la puerta y se retraen cuando se cierra. Si el conductor tiene las manos ocupadas, puede usar el nuevo botón de pie ubicado en la parte inferior del estribo para desplegarlo.',
							Image: require('./../assets/Galerias/F150PlatinumFHEV/Bullet/10.webp'),
						},
						{
							Position: '-3.826 0.472 2.013',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'FUNCIONAMIENTO MOTORIZACIÓN HÍBRIDA La F-150 Completamente Híbrida tiene dos motores: uno de combustión interna y otro eléctrico alimentado por una batería de alto voltaje de 1.5KWh. El sistema utiliza el motor eléctrico o ambos motores de acuerdo a la solicitud o demanda de potencia por parte del conductor. El cambio de modo eléctrico a híbrido se produce de manera automática e imperceptible para ofrecer la combinación perfecta de potencia y eficiencia. La batería de alto voltaje de 1.5KWh, se recarga durante el andar y almacena energía a través de dos sistemas: un generador eléctrico, que se encarga de transformar la energía mecánica proveniente del motor de combustión interna en energía eléctrica, y el Sistema de Frenado Regenerativo, que aprovecha hasta el 90% de la energía que se disipa durante el frenado para recargar la batería de alto voltaje',
							Image: require('./../assets/Galerias/F150PlatinumFHEV/Bullet/7.webp'),
						},
					],
				},
				'F-150 PLATINUM FHEV POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/F-150PlatinumHEV_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.369 -0.129 -2.318',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 PLATINUM FHEV DIG DER',
						},
						{
							Position: '-5.552 -0.129 3.637',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 PLATINUM FHEV LAT IZQ',
						},
						{
							Position: '-5.552 -0.129 -3.749',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 PLATINUM FHEV LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.182 1.547',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Escalón Integrado con Elevación Asistida La Ford F-150 Completamente Híbrida equipa un escalón integrado con elevación asistida que hará mucho más fácil el ingreso al plantón de la camioneta.',
							Image: require('./../assets/Galerias/F150PlatinumFHEV/Bullet/9.webp'),
						},
						{
							Position: '-3.826 0.182 -1.547',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Compuerta Trasera En la Ford F-150 Platinum Completamente Híbrida con solo oprimir un botón a distancia, la compuerta trasera se abre o cierre de forma controlada, proporcionando mayor comodidad especialmente si se tienen las manos ocupadas.',
							Image: require('./../assets/Galerias/F150PlatinumFHEV/Bullet/8.webp'),
						},
						{
							Position: '-3.826 0.986 -1.547',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'SUPERFICIE DE TRABAJO INTERIOR EN COMPUERTA TRASERA La Ford F-150 Completamente Híbrida fue pensada para optimizar todo el espacio disponible del vehículo. La nueva superficie interior de la compuerta trasera viene preparada para ejecutar funciones de trabajo como escribir sobre ella, medir y cortar. Incluye espacios dedicados para el soporte de dispositivos móviles, porta vasos, así como reglas para medir objetos y amarres que funcionan como abrebotellas',
							Image: require('./../assets/Galerias/F150PlatinumFHEV/Bullet/12.webp'),
						},
						{
							Position: '-3.826 0.986 1.547',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Pro Power Onboard™ La F-150 Platinum Completamente Híbrida cuenta con la novedosa tecnología Pro Power Onboard™, un generador de energía exportable a lugares remotos, de trabajo y de la vida cotidiana, con una salida de 7.2 kW*, que se puede utilizar con los 6 tomacorrientes de 120V y 240V que contiene entre el platón y cabina, fácilmente controlable desde la pantalla táctil. *La potencia máxima disponible se limita al total combinado de todos los artículos en uso. La potencia también puede limitarse en el modo de manejo o en ciertas condiciones de temperatura ambiental. Algunos equipos eléctricos requieren más potencia de arranque que la tasa de funcionamiento y puede superar la capacidad de la potencia del sistema. Consulta el manual del propietario para obtener importantes indicaciones operativas.',
							Image: require('./../assets/Galerias/F150PlatinumFHEV/Bullet/13.webp'),
						}
					],
				},

				'F-150 RAPTOR': {
					Image: require('./../assets/panoramas/Desktop/F-150Raptor_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '3.201 -0.129 0.304',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA F150',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '8.179 -0.129 -2.508',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL3',
						},
					],
					BulletsIndividual: [
						{
							Position: '-0.961 -0.129 -2.316',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 RAPTOR DIG IZQ',
						},
						{
							Position: '-5.384 -0.129 -3.814',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 RAPTOR LAT IZQ',
						},
						{
							Position: '-5.374 -0.129 3.836',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 RAPTOR LAT DER',
						},
						{
							Position: '-2.529 -0.129 -7.045',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 LARIAT SPORT',
						},
						{
							Position: '1.909 -0.129 7.022',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 XLT FHEV',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.499 -2.058',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Ford F-150 Raptor proporciona una iluminación brillante, eficiente y duradera. En la carretera, los faros delanteros con proyector LED disponibles con giro dinámico adaptativo, se ajustan para obtener claridad alrededor de las curvas, creando una iluminación dinámica para ayudar al conductor a ver hacia los lados.',
							Image: require('./../assets/Galerias/23_F150Raptor/01_Bullets/Bullet 06.webp'),
						},
						{
							Position: '-3.826 1.418 -0.020',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'El capó incorpora un nuevo extractor de calor y ventilaciones laterales funcionales, ubicadas en el borde superior de los guardabarros. Todo inspirado en las tomas de aire del avión de combate F-22 Raptor. ',
							Image: require('./../assets/Galerias/23_F150Raptor/01_Bullets/Bullet 07.webp'),
						},
						{
							Position: '-3.826 0.499 -0.020',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Parrilla Exclusiva Estilo Raptor con Letras de Imprenta FORD con luces LED incorporadas.',
							Image: require('./../assets/Galerias/23_F150Raptor/01_Bullets/Bullet 09.webp'),
						},
					],
				},
				'F-150 RAPTOR DIG DER': {
					Image: require('./../assets/panoramas/Desktop/F-150Raptor_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-3.048 -0.129 1.757',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 RAPTOR POSTERIOR',
						},
						{
							Position: '-4.427 -0.129 -1.952',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 RAPTOR LAT DER',
						},
					],
				},
				'F-150 RAPTOR DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/F-150Raptor_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '0.443 -0.129 3.898',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA F150',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.605 -0.129 2.863',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 RAPTOR',
						},
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 RAPTOR LAT IZQ',
						},
						{
							Position: '0.328 -0.129 -4.879',
							Rotation: '-90 146.081 -115.038',
							Scale: '0.4 0.4',
							goTo: 'F-150 LARIAT SPORT',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.976 1.216',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Ford F-150 Raptor proporciona una iluminación brillante, eficiente y duradera. En la carretera, los faros delanteros con proyector LED disponibles con giro dinámico adaptativo, se ajustan para obtener claridad alrededor de las curvas, creando una iluminación dinámica para ayudar al conductor a ver hacia los lados.',
							Image: require('./../assets/Galerias/23_F150Raptor/01_Bullets/Bullet 06.webp'),
						},
					],
				},
				'F-150 RAPTOR LAT DER': {
					Image: require('./../assets/panoramas/Desktop/F-150Raptor_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '-5.364 -0.129 -10.878',
							Rotation: '-90 0 0',
							Scale: '0.55 0.55',
							goTo: 'FAMILIA F150',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.608 -0.129 -6.577',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 RAPTOR',
						},
						{
							Position: '-4.608 -0.129 4.016',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 RAPTOR POSTERIOR',
						},
						{
							Position: '-2.883 -0.447 2.834',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 RAPTOR DIG DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.976 1.841',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: "La suspensión trasera de cinco enlaces tiene brazos reactores para mantener mejor la posición de los ejes en terrenos escabrosos, una barra Panhard y resortes helicoidales de 24', los más largos en su clase.* El diseño de la suspensión combiando con un software de manejo de motor más sofisticado significa que la camioneta puede enviar más torsión a las ruedas traseras, para brindar un arranque más rápido y mejor respuesta de aceleración a la vez que brinda confort, estabilidad, manejo, control y tracción a velocidad de forma simultánea.",
							Image: require('./../assets/Galerias/23_F150Raptor/01_Bullets/Bullet 08.webp'),
						},
						{
							Position: '-3.826 0.317 -3.176',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: "La Ford F-150 Raptor viene con llantas todoterreno BFGoodrich® de 35' y rines de 17' diseñados específicamente para uso off-road avanzado (tecnología bead-lock). En pocas palabras, los rines con tecnología bead-lock, o bloqueo de talón, hacen exactamente lo que su nombre indica: bloquean el talón de la llanta al rin para evitar la rotación de esta en el rin por torque o tracción extremas. Originalmente, este tipo de rines se utilizaba en aplicaciones militares, pero más tarde se popularizó en las comunidades de off-road y rock-crawling. ",
							Image: require('./../assets/Galerias/23_F150Raptor/01_Bullets/11.webp'),
						}
					],
				},
				'F-150 RAPTOR LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/F-150Raptor_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-5.185 -0.129 6.598',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 RAPTOR',
						},
						{
							Position: '-2.708 -0.129 3.176',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 RAPTOR DIG IZQ',
						},
						{
							Position: '-4.514 -0.129 -3.743',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'F-150 RAPTOR POSTERIOR',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.976 -1.841',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: "La suspensión trasera de cinco enlaces tiene brazos reactores para mantener mejor la posición de los ejes en terrenos escabrosos, una barra Panhard y resortes helicoidales de 24', los más largos en su clase.* El diseño de la suspensión combiando con un software de manejo de motor más sofisticado significa que la camioneta puede enviar más torsión a las ruedas traseras, para brindar un arranque más rápido y mejor respuesta de aceleración a la vez que brinda confort, estabilidad, manejo, control y tracción a velocidad de forma simultánea.",
							Image: require('./../assets/Galerias/23_F150Raptor/01_Bullets/Bullet 08.webp'),
						},
						{
							Position: '-3.826 0.317 3.176',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: "La Ford F-150 Raptor viene con llantas todoterreno BFGoodrich® de 35' y rines de 17' diseñados específicamente para uso off-road avanzado (tecnología bead-lock). En pocas palabras, los rines con tecnología bead-lock, o bloqueo de talón, hacen exactamente lo que su nombre indica: bloquean el talón de la llanta al rin para evitar la rotación de esta en el rin por torque o tracción extremas. Originalmente, este tipo de rines se utilizaba en aplicaciones militares, pero más tarde se popularizó en las comunidades de off-road y rock-crawling. ",
							Image: require('./../assets/Galerias/23_F150Raptor/01_Bullets/11.webp'),
						},
					],
				},
				'F-150 RAPTOR POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/F-150Raptor_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.369 -0.129 -2.318',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 RAPTOR DIG DER',
						},
						{
							Position: '-5.552 -0.129 3.637',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 RAPTOR LAT IZQ',
						},
						{
							Position: '-5.552 -0.129 -3.749',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'F-150 RAPTOR LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 -0.814 -1.967',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: "El motor EcoBoost® de 3.5L V6 High-Output se combina con un escape doble de alto desempeño para producir 450 hp y 510 lb-ft de torque. Montado debajo de la defensa para brindar mayor protección, el escape doble en 'Matte-Black' luce fabuloso y emite un sonido estridente con potencia cuando presionas el pedal del acelerador.   ",
							Image: require('./../assets/Galerias/23_F150Raptor/01_Bullets/Bullet 10.webp'),
						},
					],
				},

				'RANGER XLS DIESEL': {
					Image: require('./../assets/panoramas/Desktop/RangerXLSdiesel_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '3.201 -0.129 0.304',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA RANGER',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '8.179 -0.129 -2.508',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL7',
						},
						{
							Position: '10.664 -0.129 8.555',
							Rotation: '-90 0 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL6',
						},
					],
					BulletsIndividual: [
						{
							Position: '-1.682 -0.129 -1.656',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XLS DIESEL DIG IZQ',
						},
						{
							Position: '-5.384 -0.129 -3.014',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLS DIESEL LAT IZQ',
						},
						{
							Position: '-5.374 -0.129 3.036',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLS DIESEL LAT DER',
						},
						{
							Position: '1.592 -0.129 6.803',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED BLACK EDITION',
						},
						{
							Position: '0.647 -0.129 -4.422',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.879 0.060',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Ranger cuenta con un motor 3.2L Diesel, capaz de desarrollar impresionantes 197 hp. Adicionalmente, ofrece un torque de 470 Nm.  Disponible en las versiones Ranger XL Doble Cabina, XLS Diesel, Ranger XLT y Ranger Limited',
							Image: require('./../assets/Galerias/17_RangerXLSDiesel/01_Bullets/Bullet08.webp'),
						},
						{
							Position: '-3.826 0.489 -1.446',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Más imponente que nunca. La Ford Ranger es simplemente la pick-up mediana más innovadora del segmento. Reúne todos los avances tecnológicos, tanto por dentro como por fuera. Incorpora un nuevo lenguaje de diseño, marcado por una gran parrilla frontal trapezoidal, faros, rines y mucho más.',
							Image: require('./../assets/Galerias/17_RangerXLSDiesel/01_Bullets/Bullet06.webp'),
						},
					],
				},
				'RANGER XLS DIESEL DIG DER': {
					Image: require('./../assets/panoramas/Desktop/RangerXLSdiesel_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-3.048 -0.129 1.757',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XLS DIESEL POSTERIOR',
						},
						{
							Position: '-4.427 -0.129 -1.952',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XLS DIESEL LAT DER',
						},
						{
							Position: '-6.063 -0.129 -10.325',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED BLACK EDITION',
						},
					],
				},
				'RANGER XLS DIESEL DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/RangerXLSdiesel_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '0.443 -0.129 3.898',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA RANGER',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-2.589 -0.129 2.051',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLS DIESEL',
						},
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLS DIESEL LAT IZQ',
						},
						{
							Position: '2.345 -0.129 -0.339',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL',
						},
						{
							Position: '-4.941 -0.129 8.553',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED BLACK EDITION',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.499 0.060',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Al activar el comando sobre la consola central, el Control Electrónico de Descenso (HDC) asiste electrónicamente al conductor para mantener el control sin derrapar al descender por pendientes empinadas de baja adherencia.',
							Image: require('./../assets/Galerias/17_RangerXLSDiesel/01_Bullets/Bullet09.webp'),
						},
					],
				},
				'RANGER XLS DIESEL LAT DER': {
					Image: require('./../assets/panoramas/Desktop/RangerXLSdiesel_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '3.369 -0.129 -14.880',
							Rotation: '-95.000 180.000 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL6',
						},
					],
					BulletsIndividual: [
						{
							Position: '-4.608 -0.129 -4.605',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLS DIESEL',
						},
						{
							Position: '-4.608 -0.129 4.016',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLS DIESEL POSTERIOR',
						},
						{
							Position: '-2.883 -0.447 2.834',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLS DIESEL DIG DER',
						},
						{
							Position: '3.238 -0.447 -8.377',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED BLACK EDITION',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.222 -2.390',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Al activar el comando sobre la consola central, el Control Electrónico de Descenso (HDC) asiste electrónicamente al conductor para mantener el control sin derrapar al descender por pendientes empinadas de baja adherencia. Disponible en las versiones Ranger XL Chasis, XL Doble Cabina,  XLS Diesel, XLT y  Limited. nota legal: Imágenes de referencia. Algunas características como estribos pueden variar con respecto a la versión que se comercializa en Colombia',
							Image: require('./../assets/Galerias/17_RangerXLSDiesel/01_Bullets/Bullet09.webp'),
						},
						{
							Position: '-3.826 0.499 1.342',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Ranger XLS Diesel MT 4x4 ahora equipa el máximo exponente de la conducción todoterreno y el trabajo 4x4, el bloqueo de diferencial trasero (LRD). El LRD es la solución para los máximos desafíos que se pueden enfrentar en el trabajo y la conducción off-road. Junto a é,l se encuentra la caja de transferencia electrónica 4x4 ESOF (Electronic Shift On the Fly), perfecta para acoplar y trabar los ejes delanteros y traseros al seleccionar la conexión 4x4.',
							Image: require('./../assets/Galerias/17_RangerXLSDiesel/01_Bullets/Bullet07.webp'),
						},
						{
							Position: '-3.826 0.092 1.270',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Entrega la misma potencia a las ruedas traseras e incrementa la tracción para superar cualquier obstáculo. Ahora disponible en todas las versiones 4x4, Ranger XL Chasis, Ranger XLS Diesel Ranger XLT y Ranger Limited',
							Image: require('./../assets/Galerias/17_RangerXLSDiesel/01_Bullets/Bullet10.webp'),
						},
					],
				},
				'RANGER XLS DIESEL LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/RangerXLSdiesel_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-5.474 -0.129 5.250',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLS DIESEL',
						},
						{
							Position: '-2.708 -0.129 3.176',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLS DIESEL DIG IZQ',
						},
						{
							Position: '-4.514 -0.129 -3.743',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLS DIESEL POSTERIOR',
						},
						{
							Position: '0.330 -0.129 6.671',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.222 2.390',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Al activar el comando sobre la consola central, el Control Electrónico de Descenso (HDC) asiste electrónicamente al conductor para mantener el control sin derrapar al descender por pendientes empinadas de baja adherencia. Disponible en las versiones Ranger XL Chasis, XL Doble Cabina,  XLS Diesel, XLT y  Limited. nota legal: Imágenes de referencia. Algunas características como estribos pueden variar con respecto a la versión que se comercializa en Colombia',
							Image: require('./../assets/Galerias/17_RangerXLSDiesel/01_Bullets/Bullet09.webp'),
						},
						{
							Position: '-3.826 0.499 -1.342',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Ranger XLS Diesel MT 4x4 ahora equipa el máximo exponente de la conducción todoterreno y el trabajo 4x4, el bloqueo de diferencial trasero (LRD). El LRD es la solución para los máximos desafíos que se pueden enfrentar en el trabajo y la conducción off-road. Junto a é,l se encuentra la caja de transferencia electrónica 4x4 ESOF (Electronic Shift On the Fly), perfecta para acoplar y trabar los ejes delanteros y traseros al seleccionar la conexión 4x4.',
							Image: require('./../assets/Galerias/17_RangerXLSDiesel/01_Bullets/Bullet07.webp'),
						},
						{
							Position: '-3.826 0.092 -1.270',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Entrega la misma potencia a las ruedas traseras e incrementa la tracción para superar cualquier obstáculo. Ahora disponible en todas las versiones 4x4, Ranger XL Chasis, Ranger XLS Diesel Ranger XLT y Ranger Limited',
							Image: require('./../assets/Galerias/17_RangerXLSDiesel/01_Bullets/Bullet10.webp'),
						},
					],
				},
				'RANGER XLS DIESEL POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/RangerXLSdiesel_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-2.116 -0.129 -1.382',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XLS DIESEL DIG DER',
						},
						{
							Position: '-5.552 -0.129 2.880',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XLS DIESEL LAT IZQ',
						},
						{
							Position: '-5.552 -0.129 -2.880',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XLS DIESEL LAT DER',
						},
					],
				},

				
				'RANGER RAPTOR': {
					Image: require('./../assets/panoramas/Desktop/RangerRaptor_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '3.201 -0.129 0.304',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA RANGER',
						},
					],
					BulletsDesplazamiento: [
					],
					BulletsIndividual: [
						{
							Position: '-1.682 -0.129 -1.656',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER RAPTOR DIG IZQ',
						},
						{
							Position: '-5.384 -0.129 -3.471',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER RAPTOR LAT IZQ',
						},
						{
							Position: '-5.374 -0.129 3.468',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER RAPTOR LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.866 0.026',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Motor a gasolina 3.0L V6 EcoBoost® de 288 caballos de potencia, con sistema Anti-Retraso y transmisión automática de 10 velocidades con función Skip-Shift.',
							Image: require('./../assets/Galerias/20_RangerRaptor/01_Bullets/Bullet 07.webp'),
						},
					],
				},
				'RANGER RAPTOR DIG DER': {
					Image: require('./../assets/panoramas/Desktop/RangerRaptor_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-3.048 -0.129 1.757',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER RAPTOR POSTERIOR',
						},
						{
							Position: '-4.427 -0.129 -1.952',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER RAPTOR LAT DER',
						},
					],
				},
				'RANGER RAPTOR DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/RangerRaptor_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '0.443 -0.129 3.898',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA RANGER',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-2.589 -0.129 2.051',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER RAPTOR',
						},
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER RAPTOR LAT IZQ',
						}
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.596 -0.142',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Rines negros de 17 pulgadas con llantas BF Goodrich All-Terrain de 33 pulgadas, con una tecnología específica para adaptarse a todo tipo de desafíos, fueron diseñadas para ofrecer una vida útil más extensa.',
							Image: require('./../assets/Galerias/20_RangerRaptor/01_Bullets/Bullet 06.webp'),
						},
						{
							Position: '-3.826 0.421 -0.967',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Nueva Ranger Raptor™ cuenta con estribos laterales de aluminio reforzados y diseño todoterreno.',
							Image: require('./../assets/Galerias/20_RangerRaptor/01_Bullets/Bullet 08.webp'),
						}
					],
				},
				'RANGER RAPTOR LAT DER': {
					Image: require('./../assets/panoramas/Desktop/RangerRaptor_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '3.369 -0.129 -14.880',
							Rotation: '-95.000 180.000 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL6',
						},
					],
					BulletsIndividual: [
						{
							Position: '-4.608 -0.129 -5.338',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER RAPTOR',
						},
						{
							Position: '-4.608 -0.129 4.723',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER RAPTOR POSTERIOR',
						},
						{
							Position: '-2.883 -0.447 2.834',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER RAPTOR DIG DER',
						}
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.530 -2.478',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Rines negros de 17 pulgadas con llantas BF Goodrich All-Terrain de 33 pulgadas, con una tecnología específica para adaptarse a todo tipo de desafíos, fueron diseñadas para ofrecer una vida útil más extensa.',
							Image: require('./../assets/Galerias/20_RangerRaptor/01_Bullets/Bullet 06.webp'),
						},
						{
							Position: '-3.826 0.194 0.262',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Nueva Ranger Raptor™ cuenta con estribos laterales de aluminio reforzados y diseño todoterreno.',
							Image: require('./../assets/Galerias/20_RangerRaptor/01_Bullets/Bullet 08.webp'),
						},
						{
							Position: '-3.826 0.194 1.807',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Nueva Ranger Raptor™ incorpora un bloqueo del diferencial delantero y trasero para terrenos difíciles o rocosos. El diferencial del bloqueo es un dispositivo que se encuentra en ambos ejes, y que cuando se activa permite que ambas ruedas del eje se muevan a la misma velocidad. Puede también brindar tracción adicional en caso de que el vehículo quedara atascado.',
							Image: require('./../assets/Galerias/20_RangerRaptor/01_Bullets/Bullet 10.webp'),
						},
						{
							Position: '-3.826 1.228 1.807',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Varios elementos de diseño se pueden ver en la Nueva Ranger Raptor™,  el paquete gráfico Raptor ubicado en la parte frontal, lateral y trasera, la insignia Raptor en 3D en la compuerta trasera y el estilo audaz de sus rines color negro.',
							Image: require('./../assets/Galerias/20_RangerRaptor/01_Bullets/BUllet 09.webp'),
						},
					],
				},
				'RANGER RAPTOR LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/RangerRaptor_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-5.474 -0.129 5.914',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER RAPTOR',
						},
						{
							Position: '-2.708 -0.129 3.176',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER RAPTOR DIG IZQ',
						},
						{
							Position: '-4.514 -0.129 -4.458',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER RAPTOR POSTERIOR',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.530 2.478',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Rines negros de 17 pulgadas con llantas BF Goodrich All-Terrain de 33 pulgadas, con una tecnología específica para adaptarse a todo tipo de desafíos, fueron diseñadas para ofrecer una vida útil más extensa.',
							Image: require('./../assets/Galerias/20_RangerRaptor/01_Bullets/Bullet 06.webp'),
						},
						{
							Position: '-3.826 0.194 -0.262',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Nueva Ranger Raptor™ cuenta con estribos laterales de aluminio reforzados y diseño todoterreno.',
							Image: require('./../assets/Galerias/20_RangerRaptor/01_Bullets/Bullet 08.webp'),
						},
						{
							Position: '-3.826 0.194 -1.807',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Nueva Ranger Raptor™ incorpora un bloqueo del diferencial delantero y trasero para terrenos difíciles o rocosos. El diferencial del bloqueo es un dispositivo que se encuentra en ambos ejes, y que cuando se activa permite que ambas ruedas del eje se muevan a la misma velocidad. Puede también brindar tracción adicional en caso de que el vehículo quedara atascado.',
							Image: require('./../assets/Galerias/20_RangerRaptor/01_Bullets/Bullet 10.webp'),
						},
						{
							Position: '-3.826 1.228 -1.807',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Varios elementos de diseño se pueden ver en la Nueva Ranger Raptor™,  el paquete gráfico Raptor ubicado en la parte frontal, lateral y trasera, la insignia Raptor en 3D en la compuerta trasera y el estilo audaz de sus rines color negro.',
							Image: require('./../assets/Galerias/20_RangerRaptor/01_Bullets/BUllet 09.webp'),
						},
					],
				},
				'RANGER RAPTOR POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/RangerRaptor_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-2.116 -0.129 -1.899',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER RAPTOR DIG DER',
						},
						{
							Position: '-5.552 -0.129 3.680',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER RAPTOR LAT IZQ',
						},
						{
							Position: '-5.552 -0.129 -3.680',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER RAPTOR LAT DER',
						},
					],
				},

				'RANGER XL': {
					Image: require('./../assets/panoramas/Desktop/RangerXL_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '2.767 -0.129 1.361',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA RANGER',
						},
						{
							Position: '5.193 -0.129 -16.048',
							Rotation: '-90 0 0',
							Scale: '0.7 0.7',
							goTo: 'FAMILIA BRONCO',
						},
						{
							Position: '-4.888 -0.129 -16.048',
							Rotation: '-90 0 0',
							Scale: '0.7 0.7',
							goTo: 'FAMILIA EXPLORER',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '4.541 -0.129 -1.154',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL7',
						},
					],
					BulletsIndividual: [
						{
							Position: '-1.682 -0.129 -1.656',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XL DIG IZQ',
						},
						{
							Position: '-5.384 -0.129 -3.014',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL LAT IZQ',
						},
						{
							Position: '-5.374 -0.129 3.036',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL LAT DER',
						},
						{
							Position: '2.226 -0.129 3.287',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLS DIESEL',
						},
						{
							Position: '-2.888 -0.129 -6.461',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL CHASIS',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.879 0.060',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Nueva Ranger XL Diesel 4x4 equipa el reconocido motor Puma 3.2L Diésel de 5 cilindros que ofrece toda la potencia necesaria para enfrentar los trabajos más desafiantes, esta configuración le permite producir una potencia de 197hp @3.000 RPM y un torque 470Nm @1.750 y 2.500 RPM. Este propulsor viene acoplado a una caja mecánica de 6 velocidades que combinada con una tracción 4x4 representa la opción perfecta para aquellos que buscan el mejor rendimiento de su herramienta de trabajo.',
							Image: require('./../assets/Galerias/16_RangerXL/01_Bullets/Bullet06.webp'),
						},
						{
							Position: '-3.826 -0.801 0.060',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Preparada para rutas difíciles, la nueva Ford Ranger XL Diesel 4x4 equipa un protector inferior para el motor, la caja de transferencia y el tanque de combustible.',
							Image: require('./../assets/Galerias/16_RangerXL/01_Bullets/Bullet08.webp'),
						},
						{
							Position: '-3.826 0.499 0.060',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La nueva Ford Ranger XL cuenta con un parrilla frontal negra.',
							Image: require('./../assets/Galerias/16_RangerXL/01_Bullets/Bullet09.webp'),
						},
					],
				},
				'RANGER XL DIG DER': {
					Image: require('./../assets/panoramas/Desktop/RangerXL_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-3.048 -0.129 1.757',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XL POSTERIOR',
						},
						{
							Position: '-4.427 -0.129 -1.952',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XL LAT DER',
						},
					],
				},
				'RANGER XL DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/RangerXL_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '0.423 -0.129 5.107',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA RANGER',
						},
						{
							Position: '10.438 -0.129 -5.721',
							Rotation: '-90 0 0',
							Scale: '0.7 0.7',
							goTo: 'FAMILIA BRONCO',
						},
						{
							Position: '5.336 -0.129 -14.765',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA EXPLORER',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '2.910 -0.129 1.787',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL7',
						},
					],
					BulletsIndividual: [
						{
							Position: '-2.589 -0.129 2.051',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL',
						},
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL LAT IZQ',
						},
						{
							Position: '-2.208 -0.129 6.423',
							Rotation: '-90 146.081 -115.038',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLS DIESEL',
						},
						{
							Position: '1.151 -0.129 -5.384',
							Rotation: '-90 146.081 -115.038',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL CHASIS',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.499 0.060',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Al activar el comando sobre la consola central, el Control Electrónico de Descenso (HDC) asiste electrónicamente al conductor para mantener el control sin derrapar al descender por pendientes empinadas de baja adherencia. Disponible en las versiones Ranger XL Chasis, XL Doble Cabina,  XLS Diesel, XLT y  Limited. nota legal: Imágenes de referencia. Algunas características como estribos pueden variar con respecto a la versión que se comercializa en Colombia',
							Image: require('./../assets/Galerias/16_RangerXL/01_Bullets/Bullet07.webp'),
						},
					],
				},
				'RANGER XL LAT DER': {
					Image: require('./../assets/panoramas/Desktop/RangerXL_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '-6.660 -0.129 -11.183',
							Rotation: '-95.000 180.000 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL7',
						},
					],
					BulletsIndividual: [
						{
							Position: '-4.608 -0.129 -4.605',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL',
						},
						{
							Position: '-4.608 -0.129 4.016',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL POSTERIOR',
						},
						{
							Position: '-2.883 -0.447 2.834',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL DIG DER',
						},
						{
							Position: '-0.999 -0.447 -8.043',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLS DIESEL',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.499 -2.380',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Al activar el comando sobre la consola central, el Control Electrónico de Descenso (HDC) asiste electrónicamente al conductor para mantener el control sin derrapar al descender por pendientes empinadas de baja adherencia. Disponible en las versiones Ranger XL Chasis, XL Doble Cabina,  XLS Diesel, XLT y  Limited. nota legal: Imágenes de referencia. Algunas características como estribos pueden variar con respecto a la versión que se comercializa en Colombia',
							Image: require('./../assets/Galerias/16_RangerXL/01_Bullets/Bullet07.webp'),
						},
					],
				},
				'RANGER XL LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/RangerXL_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-5.474 -0.129 5.250',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL',
						},
						{
							Position: '-2.708 -0.129 3.176',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL DIG IZQ',
						},
						{
							Position: '-4.514 -0.129 -3.743',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL POSTERIOR',
						},
						{
							Position: '3.587 -0.129 2.377',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL CHASIS',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.499 2.400',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Al activar el comando sobre la consola central, el Control Electrónico de Descenso (HDC) asiste electrónicamente al conductor para mantener el control sin derrapar al descender por pendientes empinadas de baja adherencia. Disponible en las versiones Ranger XL Chasis, XL Doble Cabina,  XLS Diesel, XLT y  Limited. nota legal: Imágenes de referencia. Algunas características como estribos pueden variar con respecto a la versión que se comercializa en Colombia',
							Image: require('./../assets/Galerias/16_RangerXL/01_Bullets/Bullet07.webp'),
						},
					],
				},
				'RANGER XL POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/RangerXL_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-2.116 -0.129 -1.382',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XL DIG DER',
						},
						{
							Position: '-5.552 -0.129 2.880',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XL LAT IZQ',
						},
						{
							Position: '-5.552 -0.129 -2.880',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XL LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.732 -0.025',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Para una mejor experiencia en tu día a día la nueva Ford Ranger XL cuenta con asistencia de cierre de platón. ',
							Image: require('./../assets/Galerias/16_RangerXL/01_Bullets/Bullet10.webp'),
						},
					],
				},

				'EDGE ST': {
					Image: require('./../assets/panoramas/Desktop/EdgeST_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '3.201 -0.129 0.304',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA EDGE',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '8.179 -0.129 -2.508',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL5',
						},
					],
					BulletsIndividual: [
						{
							Position: '-1.682 -0.129 -1.656',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EDGE ST DIG IZQ',
						},
						{
							Position: '-5.384 -0.129 -2.614',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE ST LAT IZQ',
						},
						{
							Position: '-5.374 -0.129 3.036',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE ST LAT DER',
						},
						{
							Position: '-3.595 -0.129 -9.212',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE SEL',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.344 -0.046',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Activa automáticamente los limpiaparabrisas cuando detecta humedad o presencia de agua en el parabrisas, aumentando y disminuyendo la velocidad de barrido según la intensidad de la lluvia. ',
							Image: require('./../assets/Galerias/08_EdgeST/01_Bullets/Bullet 08.webp'),
						},
						{
							Position: '-3.826 0.959 0.055',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Nueva Edge ST es la primera SUV de altas prestaciones de Ford. Integra un potente motor turbo de 2.7L es capaz de desarrollar impresionantes 335 hp y 380 lb-pie de torque.',
							Image: require('./../assets/Galerias/08_EdgeST/01_Bullets/Bullet 6.webp'),
						},
					],
				},
				'EDGE ST DIG DER': {
					Image: require('./../assets/panoramas/Desktop/EdgeST_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-3.048 -0.129 1.757',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EDGE ST POSTERIOR',
						},
						{
							Position: '-4.427 -0.129 -1.952',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EDGE ST LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.839 -1.489',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Ajusta la velocidad de cada rueda por medio de una aplicación selectiva de los frenos a fin de mejorar la agilidad al doblar, reduciendo notablemente el subviraje y aumentando la maniobrabilidad al acelerar en las curvas.  Imágenes de referencia. Los rines no aplican para la versión comercializada en Colombia.',
							Image: require('./../assets/Galerias/08_EdgeST/01_Bullets/BUllet 09.webp'),
						},
					],
				},
				'EDGE ST DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/EdgeST_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '0.443 -0.129 3.898',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA RANGER',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-2.589 -0.129 2.051',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE ST',
						},
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE ST LAT IZQ',
						},
						{
							Position: '1.455 -0.129 -6.535',
							Rotation: '-85.712 146.081 -115.038',
							Scale: '0.4 0.4',
							goTo: 'EDGE SEL',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.118 -0.282',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Ajusta la velocidad de cada rueda por medio de una aplicación selectiva de los frenos a fin de mejorar la agilidad al doblar, reduciendo notablemente el subviraje y aumentando la maniobrabilidad al acelerar en las curvas.  Imágenes de referencia. Los rines no aplican para la versión comercializada en Colombia.',
							Image: require('./../assets/Galerias/08_EdgeST/01_Bullets/BUllet 09.webp'),
						},
					],
				},
				'EDGE ST LAT DER': {
					Image: require('./../assets/panoramas/Desktop/EdgeST_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '-10.341 -0.129 -9.820',
							Rotation: '-95.000 180.000 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL5',
						},
					],
					BulletsIndividual: [
						{
							Position: '-4.608 -0.129 -5.511',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE ST',
						},
						{
							Position: '-4.608 -0.129 4.016',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE ST POSTERIOR',
						},
						{
							Position: '-2.883 -0.447 2.834',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE ST DIG DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.118 -2.208',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Ajusta la velocidad de cada rueda por medio de una aplicación selectiva de los frenos a fin de mejorar la agilidad al doblar, reduciendo notablemente el subviraje y aumentando la maniobrabilidad al acelerar en las curvas.  Imágenes de referencia. Los rines no aplican para la versión comercializada en Colombia.',
							Image: require('./../assets/Galerias/08_EdgeST/01_Bullets/BUllet 09.webp'),
						},
					],
				},
				'EDGE ST LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/EdgeST_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-5.474 -0.129 5.250',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE ST',
						},
						{
							Position: '-2.708 -0.129 3.176',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE ST DIG IZQ',
						},
						{
							Position: '-4.514 -0.129 -3.743',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE ST POSTERIOR',
						},
						{
							Position: '5.143 -0.129 1.164',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE SEL',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.118 2.208',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Ajusta la velocidad de cada rueda por medio de una aplicación selectiva de los frenos a fin de mejorar la agilidad al doblar, reduciendo notablemente el subviraje y aumentando la maniobrabilidad al acelerar en las curvas.  Imágenes de referencia. Los rines no aplican para la versión comercializada en Colombia.',
							Image: require('./../assets/Galerias/08_EdgeST/01_Bullets/BUllet 09.webp'),
						},
					],
				},
				'EDGE ST POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/EdgeST_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-2.116 -0.129 -1.382',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'EDGE ST DIG DER',
						},
						{
							Position: '-5.552 -0.129 2.580',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EDGE ST LAT IZQ',
						},
						{
							Position: '-5.552 -0.129 -2.680',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EDGE ST LAT DER',
						},
						{
							Position: '-5.645 -0.129 8.768',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EDGE SEL',
						},
					],
				},

				'EDGE SEL': {
					Image: require('./../assets/panoramas/Desktop/EdgeSEL_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '3.201 -0.129 0.304',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA EDGE',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '8.179 -0.129 -2.508',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL5',
						},
					],
					BulletsIndividual: [
						{
							Position: '-1.682 -0.129 -1.656',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EDGE SEL DIG IZQ',
						},
						{
							Position: '-5.384 -0.129 -2.614',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE SEL LAT IZQ',
						},
						{
							Position: '-5.374 -0.129 3.036',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE SEL LAT DER',
						},
						{
							Position: '1.972 -0.129 9.130',
							Rotation: '-95 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE ST',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.761 1.134',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Detecta cuando otro auto está en el carril contiguo dentro del punto ciego, avisando por medio de una luz en los espejos laterales. La alerta de tráfico cruzado transversal puede darte avisos y detecta vehículos cuando se está retrocediendo lentamente de un lugar de estacionamiento.',
							Image: require('./../assets/Galerias/07_EdgeSEL/01_Bullets/Bullet 09.webp'),
						},
						{
							Position: '-3.826 0.959 0.055',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Nueva Edge cuenta con la nueva generación de motores turbo-cargados Ecoboost de Ford. Su potente motor turbo de 2.0L es capaz de desarrollar impresionantes 250 hp y 280 lb-pie de torque.',
							Image: require('./../assets/Galerias/07_EdgeSEL/01_Bullets/Bullet 06.webp'),
						},
						{
							Position: '-3.826 0.862 -1.179',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: ' Ya no hay que preocuparse por encender o apagar las luces, la  Edge posee faros delanteros LED, más eficientes, y que se encienden o apagan automáticamente al controlarse mediante un sensor de luz. Así mismo la  Edge incorpora luces altas automáticas, con las cuales logras la visibilidad necesaria en carretera, sin incomodar a los demás conductores.',
							Image: require('./../assets/Galerias/07_EdgeSEL/01_Bullets/Bullet 08.webp'),
						},
						{
							Position: '-3.826 1.324 -1.006',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Al detectar un posible riesgo de colisión, con el vehículo de adelante o con un peatón que entra de improviso en la trayectoria, el sistema aplicará los frenos de forma automática para prevenir totalmente o reducir las consecuencias de un eventual choque.  Imágenes de referencia. Los rines no aplican para la versión comercializada en Colombia.',
							Image: require('./../assets/Galerias/07_EdgeSEL/01_Bullets/Bullet 10.webp'),
						},
					],
				},
				'EDGE SEL DIG DER': {
					Image: require('./../assets/panoramas/Desktop/EdgeSEL_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-3.048 -0.129 1.757',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EDGE SEL POSTERIOR',
						},
						{
							Position: '-4.427 -0.129 -1.952',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EDGE SEL LAT DER',
						},
					],
				},
				'EDGE SEL DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/EdgeSEL_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '0.443 -0.129 3.898',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA EDGE',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-2.589 -0.129 2.051',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE SEL',
						},
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE SEL LAT IZQ',
						},
						{
							Position: '-6.592 -0.129 10.571',
							Rotation: '-85.712 146.081 -115.038',
							Scale: '0.4 0.4',
							goTo: 'EDGE ST',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.315 -0.756',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Detecta cuando otro auto está en el carril contiguo dentro del punto ciego, avisando por medio de una luz en los espejos laterales. La alerta de tráfico cruzado transversal puede darte avisos y detecta vehículos cuando se está retrocediendo lentamente de un lugar de estacionamiento.',
							Image: require('./../assets/Galerias/07_EdgeSEL/01_Bullets/Bullet 09.webp'),
						},
						{
							Position: '-3.826 0.923 0.222',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Al detectar un posible riesgo de colisión, con el vehículo de adelante o con un peatón que entra de improviso en la trayectoria, el sistema aplicará los frenos de forma automática para prevenir totalmente o reducir las consecuencias de un eventual choque.  Imágenes de referencia. Los rines no aplican para la versión comercializada en Colombia.',
							Image: require('./../assets/Galerias/07_EdgeSEL/01_Bullets/Bullet 10.webp'),
						},
					],
				},
				'EDGE SEL LAT DER': {
					Image: require('./../assets/panoramas/Desktop/EdgeSEL_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [
						{
							Position: '-5.495 -0.129 -13.155',
							Rotation: '-90.000 180.000 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL5',
						},
					],
					BulletsIndividual: [
						{
							Position: '-4.608 -0.129 -4.605',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE SEL',
						},
						{
							Position: '-4.608 -0.129 4.016',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE SEL POSTERIOR',
						},
						{
							Position: '-2.883 -0.447 2.834',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE SEL DIG DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.315 -1.039',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Detecta cuando otro auto está en el carril contiguo dentro del punto ciego, avisando por medio de una luz en los espejos laterales. La alerta de tráfico cruzado transversal puede darte avisos y detecta vehículos cuando se está retrocediendo lentamente de un lugar de estacionamiento.',
							Image: require('./../assets/Galerias/07_EdgeSEL/01_Bullets/Bullet 09.webp'),
						},
					],
				},
				'EDGE SEL LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/EdgeSEL_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-5.474 -0.129 5.250',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE SEL',
						},
						{
							Position: '-2.708 -0.129 3.176',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE SEL DIG IZQ',
						},
						{
							Position: '-4.514 -0.129 -3.743',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'EDGE SEL POSTERIOR',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.315 1.036',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Detecta cuando otro auto está en el carril contiguo dentro del punto ciego, avisando por medio de una luz en los espejos laterales. La alerta de tráfico cruzado transversal puede darte avisos y detecta vehículos cuando se está retrocediendo lentamente de un lugar de estacionamiento.',
							Image: require('./../assets/Galerias/07_EdgeSEL/01_Bullets/Bullet 09.webp'),
						},
					],
				},
				'EDGE SEL POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/EdgeSEL_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-2.116 -0.129 -1.382',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'EDGE SEL DIG DER',
						},
						{
							Position: '-5.552 -0.129 2.580',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EDGE SEL LAT IZQ',
						},
						{
							Position: '-5.552 -0.129 -2.680',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'EDGE SEL LAT DER',
						},
					],
				},

				'MUSTANG MACH 1': {
					Image: require('./../assets/panoramas/Desktop/MustangMach1_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '0.187 -0.129 5.845',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA MUSTANG',
						},
						{
							Position: '-7.471 -0.129 -11.532',
							Rotation: '-90 0 0',
							Scale: '0.6 0.6',
							goTo: 'FAMILIA ESCAPE',
						},
						{
							Position: '5.762 -0.129 -13.769',
							Rotation: '-90 0 0',
							Scale: '0.6 0.6',
							goTo: 'EXPEDITION LIMITED',
						},
						{
							Position: '16.347 -0.129 -10.210',
							Rotation: '-90 0 0',
							Scale: '0.6 0.6',
							goTo: 'FAMILIA EDGE',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.886 -0.129 -2.672',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'MUSTANG MACH 1 DIG IZQ',
						},
						{
							Position: '-3.943 -0.129 3.073',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'MUSTANG MACH 1 LAT DER',
						},
						{
							Position: '-4.443 -0.129 -3.227',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'MUSTANG MACH 1 LAT IZQ',
						},
						{
							Position: '2.989 -0.129 0.001',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'MUSTANG GT PREMIUM',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.201 -2.065',
							Rotation: '0 90 0',
							Scale: '0.2 0.2',
							Text: 'El Mustang Mach 1 cuenta con faros delanteros LED que se encienden de forma automática para ofrecerte mayor visibilidad y confort en condiciones de baja luminocidad.',
							Image: require('./../assets/Galerias/13_MustangMach1/01_Bullets/Bullet 10.webp'),
						},
						{
							Position: '-3.826 0.651 -0.096',
							Rotation: '0 90 0',
							Scale: '0.12 0.12',
							Text: 'El Mustang Mach 1 equipa un poderoso motor V8 de 5.0L especialmente calibrado, capaz de alcanzar una potencia de 470 hp y 410 lb-ft de torque. ',
							Image: require('./../assets/Galerias/13_MustangMach1/01_Bullets/Bullet 09.webp'),
						},
						{
							Position: '-3.826 -0.516 -0.110',
							Rotation: '0 90 0',
							Scale: '0.15 0.15',
							Text: 'La parrilla del Mach 1 recuerda al original con una malla tridimensional profunda, un emblemático diseño de nariz de tiburón y elementos que simulan unas lámparas ubicadas a cada lado de su insignia, todo esto en homenaje a la versión del 69. Debajo de cada luz de giro se encuentran unas nuevas rejillas. Los acentos negros y magnéticos de bajo brillo en todo el vehículo brindan una apariencia premium sin dejar de ser fiel a la herencia audaz y musculosa de Mach 1.',
							Image: require('./../assets/Galerias/13_MustangMach1/01_Bullets/Bullet 08.webp'),
						},
					],
				},
				'MUSTANG MACH 1 DIG DER': {
					Image: require('./../assets/panoramas/Desktop/MustangMach1_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '9.887 -0.129 4.816',
							Rotation: '-90 0 0',
							Scale: '0.6 0.6',
							goTo: 'FAMILIA F150',
						},
						{
							Position: '-7.179 -0.129 11.963',
							Rotation: '-90 0 0',
							Scale: '0.6 0.6',
							goTo: 'FAMILIA ESCAPE',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.379 -0.129 -1.912',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'MUSTANG MACH 1 LAT DER',
						},
						{
							Position: '-2.949 -0.129 2.115',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'MUSTANG MACH 1 POSTERIOR',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.800 -1.732',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'El sistema de frenos de alto rendimiento está creado especialmente para el Mustang Mach 1, incorpora calipers delanteros Brembo™ con 6 pistones que actúan sobre discos ventilados de 15 pulgadas.',
							Image: require('./../assets/Galerias/13_MustangMach1/01_Bullets/Bullet 06.webp'),
						},
					],
				},
				'MUSTANG MACH 1 DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/MustangMach1_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '-4.854 -0.129 8.124',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA MUSTANG',
						},
						{
							Position: '16.485 -0.129 3.041',
							Rotation: '-90 0 0',
							Scale: '0.7 0.7',
							goTo: 'FAMILIA EDGE',
						},
						{
							Position: '12.341 -0.129 -4.832',
							Rotation: '-90 0 0',
							Scale: '0.7 0.7',
							goTo: 'EXPEDITION LIMITED',
						},
						{
							Position: '0.961 -0.129 -12.577',
							Rotation: '-90 0 0',
							Scale: '0.7 0.7',
							goTo: 'FAMILIA ESCAPE',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'MUSTANG MACH 1 LAT IZQ',
						},
						{
							Position: '-2.397 -0.129 2.416',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'MUSTANG MACH 1',
						},

						{
							Position: '0.674 -0.129 5.073',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'MUSTANG MACH 1',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.226 -0.338',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'El sistema de frenos de alto rendimiento está creado especialmente para el Mustang Mach 1, incorpora calipers delanteros Brembo™ con 6 pistones que actúan sobre discos ventilados de 15 pulgadas.',
							Image: require('./../assets/Galerias/13_MustangMach1/01_Bullets/Bullet 06.webp'),
						},
					],
				},
				'MUSTANG MACH 1 LAT DER': {
					Image: require('./../assets/panoramas/Desktop/MustangMach1_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '1.305 -0.129 -4.038',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA MUSTANG',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.822 -0.129 -5.500',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'MUSTANG MACH 1',
						},
						{
							Position: '-2.381 -0.129 2.702',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'MUSTANG MACH 1 DIG DER',
						},
						{
							Position: '-5.014 -0.129 4.766',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'MUSTANG MACH 1 POSTERIOR',
						},
						{
							Position: '-4.575 -0.129 -7.783',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'MUSTANG GT PREMIUM',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.201 -2.465',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'El sistema de frenos de alto rendimiento está creado especialmente para el Mustang Mach 1, incorpora calipers delanteros Brembo™ con 6 pistones que actúan sobre discos ventilados de 15 pulgadas.',
							Image: require('./../assets/Galerias/13_MustangMach1/01_Bullets/Bullet 06.webp'),
						},
					],
				},
				'MUSTANG MACH 1 LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/MustangMach1_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '-8.190 -0.129 -13.368',
							Rotation: '-90 0 0',
							Scale: '0.7 0.7',
							goTo: 'FAMILIA F150',
						},
						{
							Position: '9.205 -0.129 -4.947',
							Rotation: '-90 0 0',
							Scale: '0.7 0.7',
							goTo: 'FAMILIA ESCAPE',
						},
						{
							Position: '9.416 -0.129 8.261',
							Rotation: '-90 0 0',
							Scale: '0.7 0.7',
							goTo: 'EXPEDITION LIMITED',
						},
						{
							Position: '7.067 -0.129 19.234',
							Rotation: '-90 0 0',
							Scale: '0.7 0.7',
							goTo: 'FAMILIA EDGE',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.514 -0.129 -4.668',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'MUSTANG MACH 1 POSTERIOR',
						},
						{
							Position: '-2.080 -0.129 2.635',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'MUSTANG MACH 1 DIG IZQ',
						},
						{
							Position: '-4.404 -0.129 5.111',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'MUSTANG MACH 1',
						},
						{
							Position: '-4.404 -0.129 8.536',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'MUSTANG GT PREMIUM',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.201 2.930',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'El sistema de frenos de alto rendimiento está creado especialmente para el Mustang Mach 1, incorpora calipers delanteros Brembo™ con 6 pistones que actúan sobre discos ventilados de 15 pulgadas.',
							Image: require('./../assets/Galerias/13_MustangMach1/01_Bullets/Bullet 06.webp'),
						},
					],
				},
				'MUSTANG MACH 1 POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/MustangMach1_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '9.869 -0.129 -4.209',
							Rotation: '-90.000 0 0',
							Scale: '0.6 0.6',
							goTo: 'FAMILIA F150',
						},
						{
							Position: '1.947 -0.129 9.932',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'FAMILIA ESCAPE',
						},
						{
							Position: '-6.402 -0.129 -6.271',
							Rotation: '-90.000 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA MUSTANG',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.426 -0.129 -1.778',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'MUSTANG MACH 1 DIG DER',
						},
						{
							Position: '-4.635 -0.129 3.145',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'MUSTANG MACH 1 LAT IZQ',
						},
						{
							Position: '-4.635 -0.129 -3.329',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'MUSTANG MACH 1 LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-2.949 -0.066 1.471',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'El Mustang Mach 1 viene equipado con un escape doble de desempeño con válvulas activas. Diseñado para que coincida con su carácter y lo hagas rugir a profundidad. El escape de válvulas activas te permitirá controlar el volumen del rugido de tu Mustang Mach 1. Elige entre el modo Silencioso, Normal, Deportivo o Pista. Incluso puedes definir el modo Silencioso con un temporizador.',
							Image: require('./../assets/Galerias/13_MustangMach1/01_Bullets/Bullet 07.webp'),
						},
					],
				},

				'MUSTANG GT PREMIUM': {
					Image: require('./../assets/panoramas/Desktop/MustangGTpremium_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '0.187 -0.129 -5.845',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA MUSTANG',
						},
						{
							Position: '8.355 -0.129 11.391',
							Rotation: '-83.587 -141.283 170.761',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA ESCAPE',
						},
						{
							Position: '-4.204 -0.129 11.463',
							Rotation: '-83.587 152.391 170.761',
							Scale: '0.5 0.5',
							goTo: 'EXPEDITION LIMITED',
						},
						{
							Position: '-15.721 -0.129 11.463',
							Rotation: '-83.587 152.391 170.761',
							Scale: '0.5 0.5',
							goTo: 'FAMILIA EDGE',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.886 -0.129 -2.672',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'MUSTANG GT PREMIUM DIG IZQ',
						},
						{
							Position: '-3.622 -0.129 3.277',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'MUSTANG GT PREMIUM LAT DER',
						},
						{
							Position: '-4.660 -0.129 -3.276',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'MUSTANG GT PREMIUM LAT IZQ',
						},
						{
							Position: '3.175 -0.129 0.103',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'MUSTANG MACH 1',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.201 -2.065',
							Rotation: '0 90 0',
							Scale: '0.2 0.2',
							Text: 'Cuenta con faros delanteros LED que se encienden de forma automática para ofrecerte mayor visibilidad y confort en condiciones de baja iluminocidad.',
							Image: require('./../assets/Galerias/14_MustangGTPremium/01_Bullets/Bullet 06.webp'),
						},
					],
				},
				'MUSTANG GT PREMIUM DIG DER': {
					Image: require('./../assets/panoramas/Desktop/MustangGTpremium_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '2.165 -0.129 14.776',
							Rotation: '-90 0 0',
							Scale: '0.6 0.6',
							goTo: 'FAMILIA RANGER',
						},
						{
							Position: '11.235 -0.129 -0.545',
							Rotation: '-90 0 0',
							Scale: '0.6 0.6',
							goTo: 'FAMILIA EDGE',
						},
						{
							Position: '5.886 -0.129 -10.065',
							Rotation: '-90 0 0',
							Scale: '0.6 0.6',
							goTo: 'EXPEDITION LIMITED',
						},
						{
							Position: '-4.752 -0.129 -16.872',
							Rotation: '-90 0 0',
							Scale: '0.6 0.6',
							goTo: 'MUSTANG GT PREMIUM LAT DER',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.379 -0.129 -1.912',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'MUSTANG GT PREMIUM LAT DER',
						},
						{
							Position: '-2.949 -0.129 2.115',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'MUSTANG GT PREMIUM POSTERIOR',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.194 -1.059',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Al abrir la puerta del Mustang GT Premium una luz con figura de Pony se proyectará para que puedas ver donde pisas.',
							Image: require('./../assets/Galerias/14_MustangGTPremium/01_Bullets/Bullet 10.webp'),
						},
						{
							Position: '-3.826 0.201 -0.482',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Rines de aluminio de 19” ¡Rediseñados para imponer presencia!',
							Image: require('./../assets/Galerias/14_MustangGTPremium/01_Bullets/Bullet 08.webp'),
						},
					],
				},
				'MUSTANG GT PREMIUM DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/MustangGTpremium_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '3.439 -0.129 -1.634',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA MUSTANG',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'MUSTANG GT PREMIUM LAT IZQ',
						},
						{
							Position: '-1.982 -0.129 2.755',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'MUSTANG GT PREMIUM',
						},
						{
							Position: '0.089 -0.129 4.903',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'MUSTANG MACH 1',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.257 -1.277',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Al abrir la puerta del Mustang GT Premium una luz con figura de Pony se proyectará para que puedas ver donde pisas.',
							Image: require('./../assets/Galerias/14_MustangGTPremium/01_Bullets/Bullet 10.webp'),
						},
						{
							Position: '-3.826 0.078 -0.033',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Rines de aluminio de 19” ¡Rediseñados para imponer presencia!',
							Image: require('./../assets/Galerias/14_MustangGTPremium/01_Bullets/Bullet 08.webp'),
						},
					],
				},
				'MUSTANG GT PREMIUM LAT DER': {
					Image: require('./../assets/panoramas/Desktop/MustangGTpremium_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '8.504 -0.129 12.384',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'FAMILIA EDGE',
						},
						{
							Position: '11.363 -0.129 2.045',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'EXPEDITION LIMITED',
						},
						{
							Position: '7.702 -0.129 -10.105',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'FAMILIA ESCAPE',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.822 -0.129 -5.893',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'MUSTANG GT PREMIUM',
						},
						{
							Position: '-4.822 -0.129 4.797',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'MUSTANG GT PREMIUM',
						},
						{
							Position: '-4.822 -0.129 -8.952',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'MUSTANG GT PREMIUM',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.074 0.196',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Al abrir la puerta del Mustang GT Premium una luz con figura de Pony se proyectará para que puedas ver donde pisas.',
							Image: require('./../assets/Galerias/14_MustangGTPremium/01_Bullets/Bullet 10.webp'),
						},
						{
							Position: '-3.826 0.201 2.065',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Rines de aluminio de 19” ¡Rediseñados para imponer presencia!',
							Image: require('./../assets/Galerias/14_MustangGTPremium/01_Bullets/Bullet 08.webp'),
						},
					],
				},
				'MUSTANG GT PREMIUM LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/MustangGTpremium_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '1.421 -0.129 3.926',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA MUSTANG',
						},
						{
							Position: '2.857 -0.129 20.847',
							Rotation: '-81.163 180 180',
							Scale: '0.5 0.5',
							goTo: 'FAMILIA F150',
						},
						{
							Position: '5.198 -0.129 -13.444',
							Rotation: '-83.326 0 -0.001',
							Scale: '0.5 0.5',
							goTo: 'FAMILIA RANGER',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.514 -0.129 -4.668',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'MUSTANG GT PREMIUM POSTERIOR',
						},
						{
							Position: '-4.514 -0.129 5.219',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'MUSTANG GT PREMIUM',
						},
						{
							Position: '-4.514 -0.129 8.640',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'MUSTANG MACH 1',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.074 -0.192',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Al abrir la puerta del Mustang GT Premium una luz con figura de Pony se proyectará para que puedas ver donde pisas.',
							Image: require('./../assets/Galerias/14_MustangGTPremium/01_Bullets/Bullet 10.webp'),
						},
						{
							Position: '-3.826 0.201 -2.065',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Rines de aluminio de 19” ¡Rediseñados para imponer presencia!',
							Image: require('./../assets/Galerias/14_MustangGTPremium/01_Bullets/Bullet 08.webp'),
						},
					],
				},
				'MUSTANG GT PREMIUM POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/MustangGTpremium_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '-6.224 -0.129 6.224',
							Rotation: '-90.000 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA MUSTANG',
						},
						{
							Position: '10.631 -0.129 8.511',
							Rotation: '-90.000 0 0',
							Scale: '0.6 0.6',
							goTo: 'FAMILIA RANGER',
						},
						{
							Position: '10.410 -0.129 -11.541',
							Rotation: '-85.437 -37.275 0',
							Scale: '0.6 0.6',
							goTo: 'FAMILIA EDGE',
						},
						{
							Position: '-1.438 -0.129 -13.065',
							Rotation: '-85.437 -37.275 0',
							Scale: '0.6 0.6',
							goTo: 'EXPEDITION LIMITED',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.426 -0.129 -1.778',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'MUSTANG GT PREMIUM DIG DER',
						},
						{
							Position: '-4.635 -0.129 3.145',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'MUSTANG GT PREMIUM LAT IZQ',
						},
						{
							Position: '-4.635 -0.129 -3.329',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'MUSTANG GT PREMIUM LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.257 -1.277',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Su diseño posterior es inconfundible, se roba las miradas de todos en la carretera * El alerón trasero no corresponde a la referencia que se comercializa en Colombia',
							Image: require('./../assets/Galerias/14_MustangGTPremium/01_Bullets/Bullet 09.webp'),
						},
						{
							Position: '-2.949 -0.066 1.471',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Equipado con un Escape Doble con Cuatro Puntas el cual contiene un Escape de Desempeño con Válvula Activa, te permitirá controlar el volumen del rugido de tu Mustang, ¡Ese sonido que te transmite su poder directamente!',
							Image: require('./../assets/Galerias/14_MustangGTPremium/01_Bullets/Bullet 07.webp'),
						},
					],
				},

				'BRONCO SPORT WILDTRAK': {
					Image: require('./../assets/panoramas/Desktop/BroncoSportWT_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '0.187 -0.129 5.845',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA BRONCO',
						},
						{
							Position: '1.134 -0.129 -8.434',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA MUSTANG',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.886 -0.129 -2.672',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT WILDTRAK DIG IZQ',
						},
						{
							Position: '-4.599 -0.129 -2.672',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT WILDTRAK LAT IZQ',
						},
						{
							Position: '-4.599 -0.129 2.672',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT WILDTRAK LAT DER',
						},
						{
							Position: '4.606 -0.129 -0.030',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT BIG BEND',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.021 1.321',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Diseño con significado. Este diseño, con todo el ADN Bronco Sport 4x4, se compenetra con la naturaleza, con una parrilla encapsulada de una sola pieza, faros delanteros redondos divididos en dos con una geometría perfecta, alineados con el emblema de la leyenda todo terreno: BRONCO.',
							Image: require('./../assets/Galerias/05_BroncoWT/01_Bullets/bullet9.webp'),
						},
						{
							Position: '-3.826 0.959 0.055',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'El motor más potente de su clase. La versión Wildtrak cuenta con un motor turbo EcoBoost® de 2.0 litros, capaz de desarrollar 250 hp y 376 Nm de torque para un rendimiento todo terreno de alta velocidad. La verisón Big Bend equipa un motor turbo EcoBoost® de 1.5 litros para alcanzar 181 hp y 258 Nm de torque.',
							Image: require('./../assets/Galerias/05_BroncoWT/01_Bullets/bullet6.webp'),
						},
						{
							Position: '-3.826 1.054 -1.539',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema de iluminación con tecnología LED.  Ya no hay que preocuparse por encender o apagar las luces, la Nueva Bronco Sport 4x4 posee faros delanteros y exploradoras LED, más eficientes, y que se encienden o apagan automáticamente al controlarse mediante un sensor de luz. Además, la versión Wildtrak 4x4 incorpora luces altas automáticas, con las cuales logras la visibilidad necesaria en carretera, sin incomodar a los demás conductores.',
							Image: require('./../assets/Galerias/05_BroncoWT/01_Bullets/bullet10.webp'),
						},
					],
				},
				'BRONCO SPORT WILDTRAK DIG DER': {
					Image: require('./../assets/panoramas/Desktop/BroncoSportWT_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.379 -0.129 -1.912',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT WILDTRAK LAT DER',
						},
						{
							Position: '-3.505 -0.129 2.227',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT WILDTRAK POSTERIOR',
						},
					],
				},
				'BRONCO SPORT WILDTRAK DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/BroncoSportWT_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '-5.607 -0.129 9.274',
							Rotation: '-90 0 0',
							Scale: '0.6 0.6',
							goTo: 'FAMILIA BRONCO',
						},
						{
							Position: '6.624 -0.129 -4.936',
							Rotation: '-90 0 0',
							Scale: '0.6 0.6',
							goTo: 'FAMILIA MUSTANG',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT WILDTRAK LAT IZQ',
						},
						{
							Position: '-3.002 -0.129 2.342',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT WILDTRAK',
						},
						{
							Position: '0.789 -0.129 4.964',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT BIG BEND',
						},
					],
				},
				'BRONCO SPORT WILDTRAK LAT DER': {
					Image: require('./../assets/panoramas/Desktop/BroncoSportWT_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.822 -0.129 -4.464',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'BRONCO SPORT WILDTRAK',
						},
						{
							Position: '-2.963 -0.129 2.835',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT WILDTRAK DIG DER',
						},
						{
							Position: '-4.822 -0.129 -8.772',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT BIG BEND',
						},
					],
				},
				'BRONCO SPORT WILDTRAK LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/BroncoSportWT_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.514 -0.129 -4.668',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT WILDTRAK POSTERIOR',
						},
						{
							Position: '-2.845 -0.129 2.334',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT WILDTRAK DIG IZQ',
						},
						{
							Position: '-4.495 -0.129 3.980',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT WILDTRAK',
						},
						{
							Position: '-4.473 -0.129 8.643',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT BIG BEND',
						},
					],
				},
				'BRONCO SPORT WILDTRAK POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/BroncoSportWT_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '-8.410 -0.129 8.224',
							Rotation: '-90.000 0 0',
							Scale: '0.5 0.5',
							goTo: 'FAMILIA MUSTANG',
						},
						{
							Position: '-6.725 -0.129 -5.475',
							Rotation: '-90.000 0 0',
							Scale: '0.5 0.5',
							goTo: 'FAMILIA BRONCO',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.829 -0.129 -1.234',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT WILDTRAK DIG DER',
						},
						{
							Position: '-4.686 -0.129 2.718',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT WILDTRAK LAT IZQ',
						},
						{
							Position: '-6.108 -0.129 -3.219',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT WILDTRAK LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.021 1.701',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Reflectores traseros. La compuerta trasera de la Nueva Bronco Sport 4x4 equipa reflectores de gran capacidad lumínica, perfectos para cualquier actividad después de la puesta del sol. Estos son capaces de iluminar hasta 40 metros cuadrados.',
							Image: require('./../assets/Galerias/05_BroncoWT/01_Bullets/bullet8.webp'),
						},
						{
							Position: '-3.826 2.094 0.055',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Compuerta trasera con apertura dual. La ventana de la compuerta trasera puede abrirse, brindándote un acceso más fácil y rápido al área de carga sin tener que abrir la compuerta completamente.',
							Image: require('./../assets/Galerias/05_BroncoWT/01_Bullets/bullet7.webp'),
						},
					],
				},

				'BRONCO SPORT BIG BEND': {
					Image: require('./../assets/panoramas/Desktop/BroncoSportBB_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '0.187 -0.129 -5.845',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA BRONCO',
						},
						{
							Position: '0.187 -0.129 9.754',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA MUSTANG',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.886 -0.129 -2.672',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT BIG BEND DIG IZQ',
						},
						{
							Position: '-5.161 -0.129 -2.863',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT BIG BEND LAT IZQ',
						},
						{
							Position: '-5.161 -0.129 2.863',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT BIG BEND LAT DER',
						},
						{
							Position: '4.470 -0.129 -0.003',
							Rotation: '-90 180 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT WILDTRAK',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.021 1.321',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Diseño con significado. Este diseño, con todo el ADN Bronco Sport 4x4, se compenetra con la naturaleza, con una parrilla encapsulada de una sola pieza, faros delanteros redondos divididos en dos con una geometría perfecta, alineados con el emblema de la leyenda todo terreno: BRONCO.',
							Image: require('./../assets/Galerias/05_BroncoWT/01_Bullets/bullet9.webp'),
						},
						{
							Position: '-3.826 0.959 0.055',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'El motor más potente de su clase. La versión Wildtrak cuenta con un motor turbo EcoBoost® de 2.0 litros, capaz de desarrollar 250 hp y 376 Nm de torque para un rendimiento todo terreno de alta velocidad. La verisón Big Bend equipa un motor turbo EcoBoost® de 1.5 litros para alcanzar 181 hp y 258 Nm de torque.',
							Image: require('./../assets/Galerias/05_BroncoWT/01_Bullets/bullet6.webp'),
						},
						{
							Position: '-3.826 1.054 -1.539',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema de iluminación con tecnología LED.  Ya no hay que preocuparse por encender o apagar las luces, la Nueva Bronco Sport 4x4 posee faros delanteros y exploradoras LED, más eficientes, y que se encienden o apagan automáticamente al controlarse mediante un sensor de luz. Además, la versión Wildtrak 4x4 incorpora luces altas automáticas, con las cuales logras la visibilidad necesaria en carretera, sin incomodar a los demás conductores.',
							Image: require('./../assets/Galerias/05_BroncoWT/01_Bullets/bullet10.webp'),
						},
					],
				},
				'BRONCO SPORT BIG BEND DIG DER': {
					Image: require('./../assets/panoramas/Desktop/BroncoSportBB_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.379 -0.129 -1.912',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT BIG BEND LAT DER',
						},
						{
							Position: '-3.505 -0.129 2.227',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT BIG BEND POSTERIOR',
						},
					],
				},
				'BRONCO SPORT BIG BEND DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/BroncoSportBB_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '4.929 -0.129 -1.305',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA BRONCO',
						},
						{
							Position: '-7.092 -0.129 10.287',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA MUSTANG',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT BIG BEND LAT IZQ',
						},
						{
							Position: '-2.988 -0.129 1.709',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT BIG BEND',
						},
						{
							Position: '1.649 -0.129 6.071',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT WILDTRAK',
						},
					],
				},
				'BRONCO SPORT BIG BEND LAT DER': {
					Image: require('./../assets/panoramas/Desktop/BroncoSportBB_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.822 -0.129 -4.464',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'BRONCO SPORT BIG BEND',
						},
						{
							Position: '-2.963 -0.129 2.835',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT BIG BEND DIG DER',
						},
						{
							Position: '-4.822 -0.129 -8.772',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT WILDTRAK',
						},
					],
				},
				'BRONCO SPORT BIG BEND LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/BroncoSportBB_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.514 -0.129 -4.080',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT BIG BEND POSTERIOR',
						},
						{
							Position: '-2.785 -0.129 3.169',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT BIG BEND DIG IZQ',
						},
						{
							Position: '-4.339 -0.129 4.550',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT BIG BEND',
						},
						{
							Position: '-4.672 -0.129 9.855',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT WILDTRAK',
						},
					],
				},
				'BRONCO SPORT BIG BEND POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/BroncoSportBB_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.829 -0.129 -1.234',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT BIG BEND DIG DER',
						},
						{
							Position: '-4.686 -0.129 2.718',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT BIG BEND LAT IZQ',
						},
						{
							Position: '-6.108 -0.129 -3.219',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT BIG BEND LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.021 1.701',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Reflectores traseros. La compuerta trasera de la Nueva Bronco Sport 4x4 equipa reflectores de gran capacidad lumínica, perfectos para cualquier actividad después de la puesta del sol. Estos son capaces de iluminar hasta 40 metros cuadrados.',
							Image: require('./../assets/Galerias/05_BroncoWT/01_Bullets/bullet8.webp'),
						},
						{
							Position: '-3.826 2.094 0.055',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Compuerta trasera con apertura dual. La ventana de la compuerta trasera puede abrirse, brindándote un acceso más fácil y rápido al área de carga sin tener que abrir la compuerta completamente.',
							Image: require('./../assets/Galerias/05_BroncoWT/01_Bullets/bullet7.webp'),
						},
					],
				},

				/*'BRONCO SPORT OUTER BANKS': {
					Image: require('./../assets/panoramas/Desktop/BroncoSportOB_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '0.466 -0.129 4.074',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA BRONCO',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.886 -0.129 -2.672',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT OUTER BANKS DIG IZQ',
						},
						{
							Position: '-4.599 -0.129 -2.672',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT OUTER BANKS LAT IZQ',
						},
						{
							Position: '-4.599 -0.129 2.672',
							Rotation: '-95 180 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT OUTER BANKS LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.228 0.568',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Diseño con significado. Este diseño, con todo el ADN Bronco Sport 4x4, se compenetra con la naturaleza, con una parrilla encapsulada de una sola pieza, faros delanteros redondos divididos en dos con una geometría perfecta, alineados con el emblema de la leyenda todo terreno: BRONCO.',
							Image: require('./../assets/Galerias/Bronco_OB/Bullets/Bullet09.webp'),
						},
						{
							Position: '-3.826 0.959 0.055',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Motor turbo EcoBoost® de 1.5 litros, capaz de desarrollar 181 hp y 258 Nm de torque para un rendimiento todo terreno de alta velocidad.',
							Image: require('./../assets/Galerias/Bronco_OB/Bullets/Bullet06.webp'),
						},
						{
							Position: '-3.826 1.054 -1.539',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema de iluminación con tecnología LED.  Ya no hay que preocuparse por encender o apagar las luces, la Bronco Sport 4x4 posee faros delanteros y exploradoras LED, más eficientes, y que se encienden o apagan automáticamente al controlarse mediante un sensor de luz.',
							Image: require('./../assets/Galerias/Bronco_OB/Bullets/Bullet10.webp'),
						},
					],
				},
				'BRONCO SPORT OUTER BANKS DIG DER': {
					Image: require('./../assets/panoramas/Desktop/BroncoSportOB_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.379 -0.129 -1.912',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT OUTER BANKS LAT DER',
						},
						{
							Position: '-3.505 -0.129 2.227',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT OUTER BANKS POSTERIOR',
						},
					],
				},
				'BRONCO SPORT OUTER BANKS DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/BroncoSportOB_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '1.542 -0.129 1.036',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA BRONCO',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT OUTER BANKS LAT IZQ',
						},
						{
							Position: '-2.988 -0.129 1.709',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT OUTER BANKS',
						},
					],
				},
				'BRONCO SPORT OUTER BANKS LAT DER': {
					Image: require('./../assets/panoramas/Desktop/BroncoSportOB_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.822 -0.129 -4.464',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'BRONCO SPORT OUTER BANKS',
						},
						{
							Position: '-2.963 -0.129 2.835',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT OUTER BANKS DIG DER',
						},
					],
				},
				'BRONCO SPORT OUTER BANKS LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/BroncoSportOB_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.514 -0.129 -3.448',
							Rotation: '-90 0 0',
							Scale: '0.25 0.25',
							goTo: 'BRONCO SPORT OUTER BANKS POSTERIOR',
						},
						{
							Position: '-2.785 -0.129 3.169',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT OUTER BANKS DIG IZQ',
						},
						{
							Position: '-4.339 -0.129 4.550',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'BRONCO SPORT OUTER BANKS',
						},
					],
				},
				'BRONCO SPORT OUTER BANKS POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/BroncoSportOB_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.829 -0.129 -1.234',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT OUTER BANKS DIG DER',
						},
						{
							Position: '-4.686 -0.129 2.718',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT OUTER BANKS LAT IZQ',
						},
						{
							Position: '-6.108 -0.129 -3.219',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'BRONCO SPORT OUTER BANKS LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.959 0.055',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Compuerta trasera con apertura dua. La ventana de la compuerta trasera puede abrirse, brindándote un acceso más fácil y rápido al área de carga sin tener que abrir la compuerta completamente.',
							Image: require('./../assets/Galerias/Bronco_OB/Bullets/Bullet07.webp'),
						},
						{
							Position: '-3.826 0.021 1.004',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Reflectores traseros. La compuerta trasera de la Bronco Sport 4x4 equipa reflectores de gran capacidad lumínica, perfectos para cualquier actividad después de la puesta del sol. Estos son capaces de iluminar hasta 40 metros cuadrados.',
							Image: require('./../assets/Galerias/Bronco_OB/Bullets/Bullet08.webp'),
						},
					],
				},*/

				'RANGER FX4': {
					Image: require('./../assets/panoramas/Desktop/RangerFX4_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '-0.593 -0.129 3.981',
							Rotation: '-90.000 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA RANGER2',
						},
						
					],
					BulletsDesplazamiento: [
						{
							Position: '2.415 -0.129 7.070',
							Rotation: '-90.000 0 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL5',
						},
					],
					BulletsIndividual: [
						{
							Position: '-1.829 -0.129 -1.234',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER FX4 DIG IZQ',
						},
						{
							Position: '-4.686 -0.129 2.718',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER FX4 LAT DER',
						},
						{
							Position: '-6.108 -0.129 -3.219',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER FX4 LAT IZQ',
						},
						{
							Position: '-4.297 -0.129 7.070',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XLT',
						},
						{
							Position: '2.759 -0.129 -7.971',
							Rotation: '-90.000 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.591 -1.346',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistemade IluminaciónBi-Led. La Ford Ranger ahora cuenta con faros delanteros Bi-Led (altas y bajas) que se encienden de forma automática para ofrecerte mayor visibilidad y confort en condiciones de baja luminosidad. Las luces Bi-Led ofrecen mayor ahorro y alcance. Así mismo la Ford Ranger incorpora luces altas automáticas, con las cuales logras la visibilidad necesaria en carretera sin incomodar a los demás conductores. No necesitarás preocuparte por encender o apagar las luces.',
							Image: require('./../assets/Galerias/27_RangerFX4/Bullet/2.webp'),
						},
						{
							Position: '-3.826 0.419 -0.108',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Nueva Ranger FX4 presenta el diseño exterior característico del paquete off-road de Ford FX4: estilo deportivo y presencia desafiante',
							Image: require('./../assets/Galerias/27_RangerFX4/Bullet/6.webp'),
						},
						{
							Position: '-3.826 0.419 0.827',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Nueva Ranger FX4 viene a potenciar la versátil línea Ranger. Así, esta variante audaz utiliza la base de Ranger XLT 4x4 AT y suma el exclusivo paquete FX4, un atributo único que la convierte en un vehículo ideal para el disfrute todoterreno. ',
							Image: require('./../assets/Galerias/27_RangerFX4/Bullet/7.webp'),
						},
						{
							Position: '-3.826 0.419 -1.041',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Parrilla exterior negra con diseño exclusivo',
							Image: require('./../assets/Galerias/27_RangerFX4/Bullet/9.webp'),
						},
					],
				},
				'RANGER FX4 DIG DER': {
					Image: require('./../assets/panoramas/Desktop/RangerFX4_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-3.505 -0.129 2.227',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER FX4 POSTERIOR',
						},
						{
							Position: '-4.379 -0.129 -1.912',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER FX4 LAT DER',
						},
						{
							Position: '-1.213 -0.129 -7.459',
							Rotation: '-90 0 0',
							Scale: '0.5 0.5',
							goTo: 'RANGER XLT',
						},
					],
				},
				'RANGER FX4 DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/RangerFX4_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '-4.496 -0.129 7.355',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA RANGER2',
						}
					],
					BulletsDesplazamiento: [
						{
							Position: '-3.511 -0.129 13.007',
							Rotation: '-90 0 0',
							Scale: '0.6 0.6',
							goTo: 'GENERAL5',
						},
						{
							Position: '2.784 -0.129 5.019',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL6',
						}
					],
					BulletsIndividual: [
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER FX4 LAT IZQ',
						},
						{
							Position: '-2.988 -0.129 1.709',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER FX4',
						},
						{
							Position: '5.413 -0.129 -1.361',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED',
						},
					],
				},
				'RANGER FX4 LAT DER': {
					Image: require('./../assets/panoramas/Desktop/RangerFX4_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.822 -0.129 -4.464',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'RANGER FX4',
						},
						{
							Position: '-2.963 -0.129 2.835',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER FX4 DIG DER',
						},
						{
							Position: '3.749 -0.129 -0.880',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLT',
						}
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.771 1.162',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Barra de San Antonio deportiva color negro',
							Image: require('./../assets/Galerias/27_RangerFX4/Bullet/2.webp'),
						},
						{
							Position: '-3.826 0.244 1.537',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Nuevo diseño de rines de 18 pulgadas color negro',
							Image: require('./../assets/Galerias/27_RangerFX4/Bullet/6.webp'),
						},
						{
							Position: '-3.826 0.419 -0.981',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Paquete gráfico exclusivo FX4',
							Image: require('./../assets/Galerias/27_RangerFX4/Bullet/6.webp'),
						}
					],
				},
				'RANGER FX4 LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/RangerFX4_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.514 -0.129 -4.080',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER FX4 POSTERIOR',
						},
						{
							Position: '-2.785 -0.129 3.169',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER FX4 DIG IZQ',
						},
						{
							Position: '-4.339 -0.129 4.550',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER FX4',
						}
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.771 -1.162',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Barra de San Antonio deportiva color negro',
							Image: require('./../assets/Galerias/27_RangerFX4/Bullet/2.webp'),
						},
						{
							Position: '-3.826 0.244 -1.537',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Nuevo diseño de rines de 18 pulgadas color negro',
							Image: require('./../assets/Galerias/27_RangerFX4/Bullet/6.webp'),
						},
						{
							Position: '-3.826 0.419 0.981',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Paquete gráfico exclusivo FX4',
							Image: require('./../assets/Galerias/27_RangerFX4/Bullet/6.webp'),
						}
					],
				},
				'RANGER FX4 POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/RangerFX4_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.829 -0.129 -1.234',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER FX4 DIG DER',
						},
						{
							Position: '-4.686 -0.129 2.718',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER FX4 LAT IZQ',
						},
						{
							Position: '-6.108 -0.129 -3.219',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER FX4 LAT DER',
						},
					],
					BulletsInfo: [
					],
				},

				'RANGER LIMITED': {
					Image: require('./../assets/panoramas/Desktop/RangerLimited_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '6.451 -0.129 -7.329',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'FAMILIA RANGER',
						},
						{
							Position: '-3.569 -0.129 11.119',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'FAMILIA RANGER2',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '-0.609 -0.129 14.522',
							Rotation: '-90.000 0 0',
							Scale: '0.6 0.6',
							goTo: 'GENERAL5',
						},
						{
							Position: '5.083 -0.129 3.924',
							Rotation: '-90.000 0 0',
							Scale: '0.6 0.6',
							goTo: 'GENERAL6',
						},
						{
							Position: '6.896 -0.129 -3.461',
							Rotation: '-90.000 0 0',
							Scale: '0.6 0.6',
							goTo: 'GENERAL7',
						},
					],
					BulletsIndividual: [
						{
							Position: '-1.829 -0.129 -1.234',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER LIMITED DIG IZQ',
						},
						{
							Position: '-4.686 -0.129 2.718',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER LIMITED LAT DER',
						},
						{
							Position: '-6.108 -0.129 -3.219',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER LIMITED LAT IZQ',
						},
						{
							Position: '1.870 -0.129 -4.646',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER LIMITED BLACK EDITION',
						},
						{
							Position: '-5.111 -0.129 6.755',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER FX4',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.591 -1.346',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Nuevo Sistema de iluminación con tecnología Bi-Led. La Ford Ranger ahora cuenta con faros delanteros Bi-Led (Altas y bajas) que se encienden de forma automática para ofrecerte mayor visibilidad y confort en condiciones de baja iluminocidad. Las luces Bi-Led ofrecen mayor ahorro y alcance. Así mismo la Ford Ranger incorpora luces altas automáticas, con las cuales logras la visibilidad necesaria en carretera, sin incomodar a los demás conductores No necesitaras preocuparte por encender o apagar las luces!  Disponible en la versión Ranger Limited',
							Image: require('./../assets/Galerias/26_RangerLimited/Bullet/6.webp'),
						},
						{
							Position: '-3.826 1.616 0.078',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Limpiabrisas delantero con sensor de lluvia. Activa automáticamente los limpiaparabrisas cuando detecta humedad o presencia de agua en el parabrisas, aumentando y disminuyendo la velocidad de barrido según la intensidad de la lluvia. Disponible en las versiones Ranger XLT y Ranger Limited',
							Image: require('./../assets/Galerias/26_RangerLimited/Bullet/7.webp'),
						},
					],
				},
				'RANGER LIMITED DIG DER': {
					Image: require('./../assets/panoramas/Desktop/RangerLimited_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.379 -0.129 -1.912',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER LIMITED LAT DER',
						},
						{
							Position: '-3.505 -0.129 2.227',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER LIMITED POSTERIOR',
						},
						{
							Position: '-1.149 -0.129 -7.034',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER FX4',
						},
					],
				},
				'RANGER LIMITED DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/RangerLimited_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '-7.092 -0.129 10.287',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA RANGER',
						}
					],
					BulletsDesplazamiento: [
						{
							Position: '-12.512 -0.129 12.747',
							Rotation: '-90 0 0',
							Scale: '0.6 0.6',
							goTo: 'GENERAL5',
						},
						{
							Position: '-0.854 -0.129 9.767',
							Rotation: '-90 0 0',
							Scale: '0.6 0.6',
							goTo: 'GENERAL6',
						},
						{
							Position: '10.896 -0.129 2.986',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL7',
						},
					],
					BulletsIndividual: [
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED LAT IZQ',
						},
						{
							Position: '-2.988 -0.129 1.709',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED',
						},
						{
							Position: '3.315 -0.129 0.134',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED BLACK EDITION',
						},
					],
				},
				'RANGER LIMITED LAT DER': {
					Image: require('./../assets/panoramas/Desktop/RangerLimited_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.822 -0.129 -4.464',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'RANGER LIMITED',
						},
						{
							Position: '-2.963 -0.129 2.835',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED DIG DER',
						},
						{
							Position: '3.323 -0.129 -0.183',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER FX4',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.290 -2.352',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema de monitoreo de la presión de los neumáticos. Los sensores del Sistema de monitoreo de presión de neumáticos muestran la presión de aire de cada neumático. De esta manera conduces en óptimas condiciones, logrando mayor seguridad y eficiencia en el consumo de combustible. Disponible en la versión Ranger Limited.',
							Image: require('./../assets/Galerias/26_RangerLimited/Bullet/6.webp'),
						}
					],
				},
				'RANGER LIMITED LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/RangerLimited_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.514 -0.129 -4.080',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED POSTERIOR',
						},
						{
							Position: '-2.785 -0.129 3.169',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED DIG IZQ',
						},
						{
							Position: '-4.339 -0.129 4.550',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED',
						}
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.290 2.352',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema de monitoreo de la presión de los neumáticos. Los sensores del Sistema de monitoreo de presión de neumáticos muestran la presión de aire de cada neumático. De esta manera conduces en óptimas condiciones, logrando mayor seguridad y eficiencia en el consumo de combustible. Disponible en la versión Ranger Limited.',
							Image: require('./../assets/Galerias/26_RangerLimited/Bullet/6.webp'),
						}
					],
				},
				'RANGER LIMITED POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/RangerLimited_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.829 -0.129 -1.234',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER LIMITED DIG DER',
						},
						{
							Position: '-4.686 -0.129 2.718',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER LIMITED LAT IZQ',
						},
						{
							Position: '-4.272 -0.129 -3.185',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER LIMITED LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.840 -0.187',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Compuerta del platón con asistencia. Mayor flexibilidad y suavidad para el usuario durante la apertura y cierre de la compuerta (hasta un 60% menos de esfuerzo).',
							Image: require('./../assets/Galerias/26_RangerLimited/Bullet/6.webp'),
						}
					],
				},

				'RANGER LIMITED BLACK EDITION': {
					Image: require('./../assets/panoramas/Desktop/RangerLimitedBlackEdition_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '5.852 -0.129 -4.399',
							Rotation: '-90.000 0 0',
							Scale: '0.5 0.5',
							goTo: 'FAMILIA RANGER',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '2.523 -0.129 8.685',
							Rotation: '-90.000 0 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL6',
						},
						{
							Position: '10.730 -0.129 -2.312',
							Rotation: '-90.000 0 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL7',
						},
					],
					BulletsIndividual: [
						{
							Position: '-1.829 -0.129 -1.234',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER LIMITED BLACK EDITION DIG IZQ',
						},
						{
							Position: '-4.686 -0.129 2.718',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER LIMITED BLACK EDITION LAT DER',
						},
						{
							Position: '-6.108 -0.129 -3.219',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER LIMITED BLACK EDITION LAT IZQ',
						},
						{
							Position: '-0.064 -0.129 -7.281',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XLS DIESEL',
						},
						{
							Position: '0.114 -0.129 5.797',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER LIMITED',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.471 0.609',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Control de velocidad adaptativo Mide la distancia y velocidad de los vehículos que se encuentran en frente. Si estos aumentan o reducen su velocidad, la Ford Ranger ajustará de igual forma su velocidad acelerando o activando los frenos de forma dosificada.',
							Image: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Bullet/1.webp'),
						},
						{
							Position: '-3.826 1.616 0.078',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Sistema depermanencia en el carril. Detecta las líneas marcadas en el camino y ayuda al conductor a mantenerse dentro del carril. Utiliza una cámara frontal que monitorea la posición del vehículo para advertir e incluso corregir la trayectoria cuando se desvía involuntariamente.',
							Image: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Bullet/2.webp'),
						},
						{
							Position: '-3.826 0.591 -1.346',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Control Automático de Luces Altas. Al detectar otro vehículo circulando delante o en sentido contrario, desactiva las luces altas (dejando solo las luces bajas activas) para evitar encandilar a otros conductores.',
							Image: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Bullet/4.webp'),
						},
						{
							Position: '-3.826 0.461 0.078',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La nueva Ranger Limited Black Edition cuenta con un diseño exterior exclusivo ',
							Image: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Bullet/6.webp'),
						},
						{
							Position: '-3.826 0.471 -0.621',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Parrilla exclusiva Black',
							Image: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Bullet/7.webp'),
						},
					],
				},
				'RANGER LIMITED BLACK EDITION DIG DER': {
					Image: require('./../assets/panoramas/Desktop/RangerLimitedBlackEdition_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.379 -0.129 -1.912',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER LIMITED BLACK EDITION LAT DER',
						},
						{
							Position: '-3.505 -0.129 2.227',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER LIMITED BLACK EDITION POSTERIOR',
						},
						{
							Position: '-1.344 -0.129 -7.364',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER LIMITED',
						},
					],
				},
				'RANGER LIMITED BLACK EDITION DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/RangerLimitedBlackEdition_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '3.442 -0.129 0.971',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA RANGER',
						}
					],
					BulletsDesplazamiento: [
						{
							Position: '6.340 -0.129 1.088',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL7',
						}
					],
					BulletsIndividual: [
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED BLACK EDITION LAT IZQ',
						},
						{
							Position: '-2.988 -0.129 1.709',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED BLACK EDITION',
						},
						{
							Position: '2.264 -0.129 -2.607',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLS DIESEL',
						},
					],
				},
				'RANGER LIMITED BLACK EDITION LAT DER': {
					Image: require('./../assets/panoramas/Desktop/RangerLimitedBlackEdition_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.822 -0.129 -4.464',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'RANGER LIMITED BLACK EDITION',
						},
						{
							Position: '-2.963 -0.129 2.835',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED BLACK EDITION DIG DER',
						},
						{
							Position: '3.363 -0.129 0.049',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.798 1.545',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Barra San Antonio tubular exclusive Black',
							Image: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Bullet/8.webp'),
						},
						{
							Position: '-3.826 0.181 -0.233',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Estribos planos Night Black',
							Image: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Bullet/9.webp'),
						},
						{
							Position: '-3.826 0.409 2.005',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Rines de 18 pulgadas Dark Black Special Edition',
							Image: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Bullet/10.webp'),
						}
					],
				},
				'RANGER LIMITED BLACK EDITION LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/RangerLimitedBlackEdition_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.514 -0.129 -4.080',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED BLACK EDITION POSTERIOR',
						},
						{
							Position: '-2.785 -0.129 3.169',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED BLACK EDITION DIG IZQ',
						},
						{
							Position: '-4.339 -0.129 4.550',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER LIMITED BLACK EDITION',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.798 -1.545',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Barra San Antonio tubular exclusive Black',
							Image: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Bullet/8.webp'),
						},
						{
							Position: '-3.826 0.181 0.233',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Estribos planos Night Black',
							Image: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Bullet/9.webp'),
						},
						{
							Position: '-3.826 0.409 -2.005',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Rines de 18 pulgadas Dark Black Special Edition',
							Image: require('./../assets/Galerias/24_RangerLimitedBlackEdition/Bullet/10.webp'),
						}
					],
				},
				'RANGER LIMITED BLACK EDITION POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/RangerLimitedBlackEdition_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.829 -0.129 -1.234',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER LIMITED BLACK EDITION DIG DER',
						},
						{
							Position: '-4.686 -0.129 2.718',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER LIMITED BLACK EDITION LAT IZQ',
						},
						{
							Position: '-6.108 -0.129 -3.219',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER LIMITED BLACK EDITION LAT DER',
						},
					],
					BulletsInfo: [
					],
				},

				'RANGER XL CHASIS': {
					Image: require('./../assets/panoramas/Desktop/RangerXLchasis_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '-5.642 -0.129 -11.844',
							Rotation: '-90.000 0 0',
							Scale: '0.5 0.5',
							goTo: 'FAMILIA EXPLORER',
						},
						{
							Position: '5.241 -0.129 -14.292',
							Rotation: '-90.000 0 0',
							Scale: '0.5 0.5',
							goTo: 'FAMILIA BRONCO',
						},
						{
							Position: '5.241 -0.129 7.442',
							Rotation: '-90.000 0 0',
							Scale: '0.5 0.5',
							goTo: 'FAMILIA RANGER',
						}
					],
					BulletsDesplazamiento: [
						{
							Position: '5.241 -0.129 2.451',
							Rotation: '-90.000 0 0',
							Scale: '0.5 0.5',
							goTo: 'GENERAL7',
						}
					],
					BulletsIndividual: [
						{
							Position: '-1.829 -0.129 -1.234',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XL CHASIS DIG IZQ',
						},
						{
							Position: '-4.686 -0.129 2.718',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XL CHASIS LAT DER',
						},
						{
							Position: '-6.108 -0.129 -3.219',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XL CHASIS LAT IZQ',
						},
						{
							Position: '1.727 -0.129 7.442',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XL',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.591 -1.346',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Luces frontales halógenas.',
							Image: require('./../assets/Galerias/25_RangerXLChasis/Bullet/10.webp'),
						},
					],
				},
				'RANGER XL CHASIS DIG DER': {
					Image: require('./../assets/panoramas/Desktop/RangerXLchasis_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.379 -0.129 -1.912',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XL CHASIS LAT DER',
						},
						{
							Position: '-3.505 -0.129 2.227',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XL CHASIS POSTERIOR',
						},
					],
				},
				'RANGER XL CHASIS DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/RangerXLchasis_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '13.003 -0.129 -5.503',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA BRONCO',
						},
						{
							Position: '2.737 -0.129 -13.644',
							Rotation: '-90 0 0',
							Scale: '0.6 0.6',
							goTo: 'FAMILIA EXPLORER',
						},
						{
							Position: '-2.231 -0.129 12.617',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA RANGER',
						},
					],
					BulletsDesplazamiento: [
						{
							Position: '0.913 -0.129 6.997',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'GENERAL7',
						}
					],
					BulletsIndividual: [
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL CHASIS LAT IZQ',
						},
						{
							Position: '-2.988 -0.129 1.709',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL CHASIS ',
						},
						{
							Position: '-4.740 -0.129 9.402',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL DIESEL',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.839 0.510',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Luces frontales halógenas.',
							Image: require('./../assets/Galerias/25_RangerXLChasis/Bullet/10.webp'),
						},
						{
							Position: '-3.826 0.252 -0.155',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Rines de 16" de Acero y tamaño de las llanatas de 255/70R16 BSW A-T',
							Image: require('./../assets/Galerias/25_RangerXLChasis/Bullet/9.webp'),
						},
					],
				},
				'RANGER XL CHASIS LAT DER': {
					Image: require('./../assets/panoramas/Desktop/RangerXLchasis_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.822 -0.129 -4.464',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'RANGER XL CHASIS',
						},
						{
							Position: '-2.963 -0.129 2.835',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL CHASIS DIG DER',
						}
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.839 1.083',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Protectores inferiores de radiador, cubre cárter, protector para tanque de combustible, protector de caja reductora.',
							Image: require('./../assets/Galerias/25_RangerXLChasis/Bullet/8.webp'),
						},
						{
							Position: '-3.826 0.394 1.714',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Entrega la misma potencia a las ruedas traseras e incrementa la tracción para superar cualquier obstáculo. Ahora disponible en las versiones Ranger XL Chasis, XLS Diesel, XLT y Limited legal: Imágenes de referencia. Algunas características como estribos pueden variar con respecto a la versión que se comercializa en Colombia.',
							Image: require('./../assets/Galerias/25_RangerXLChasis/Bullet/7.webp'),
						},
					],
				},
				'RANGER XL CHASIS LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/RangerXLchasis_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.514 -0.129 -4.080',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL CHASIS POSTERIOR',
						},
						{
							Position: '-2.785 -0.129 3.169',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL CHASIS DIG IZQ',
						},
						{
							Position: '-4.339 -0.129 4.550',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XL CHASIS ',
						}
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.839 -1.083',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Protectores inferiores de radiador, cubre cárter, protector para tanque de combustible, protector de caja reductora.',
							Image: require('./../assets/Galerias/25_RangerXLChasis/Bullet/8.webp'),
						},
						{
							Position: '-3.826 0.394 -1.714',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Entrega la misma potencia a las ruedas traseras e incrementa la tracción para superar cualquier obstáculo. Ahora disponible en las versiones Ranger XL Chasis, XLS Diesel, XLT y Limited legal: Imágenes de referencia. Algunas características como estribos pueden variar con respecto a la versión que se comercializa en Colombia.',
							Image: require('./../assets/Galerias/25_RangerXLChasis/Bullet/7.webp'),
						},
					],
				},
				'RANGER XL CHASIS POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/RangerXLchasis_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.829 -0.129 -1.234',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XL CHASIS DIG DER',
						},
						{
							Position: '-4.686 -0.129 2.718',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XL CHASIS LAT IZQ',
						},
						{
							Position: '-6.108 -0.129 -3.219',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XL CHASIS LAT DER',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 -0.081 0.073',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Gracias a la robustez, la potencia de su motor, y los sistemas eléctrónicos de control, la Nueva Ranger XL Chasis Diesel 4x4 puede transportar cargas de tamaño y peso significativo ya que posee una sobresaliente  capacidad de carga máxima en su categoría, de 1.357 kg (*). Junto con el control de carga adaptativo y el control antivuelco, la Ranger XL Chasis Diesel 4x4 ofrece una increible combinación de fuerza, tecnología y seguridad. (*)Capacidad de Carga Máxima, incluye peso de la carrocería, pasajeros y combustible.',
							Image: require('./../assets/Galerias/25_RangerXLChasis/Bullet/6.webp'),
						}
					],
				},

				'RANGER XLT': {
					Image: require('./../assets/panoramas/Desktop/RangerXLT_Frente.webp'),
					Rotation: '0 90 0',
					Bullets: [
					],
					BulletsDesplazamiento: [
						{
							Position: '3.129 -0.129 3.704',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'GENERAL5',
						},
						{
							Position: '6.111 -0.129 -6.378',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'GENERAL6',
						},
					],
					BulletsIndividual: [
						{
							Position: '-1.829 -0.129 -1.234',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XLT DIG IZQ',
						},
						{
							Position: '-4.686 -0.129 2.718',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XLT LAT DER',
						},
						{
							Position: '-6.108 -0.129 -3.219',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XLT LAT IZQ',
						},
						{
							Position: '2.653 -0.129 -7.943',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER FX4',
						},
					],
					BulletsInfo: [
						{
							Position: '-3.826 1.546 0.020',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Limpiabrisas delantero con sensor de lluvia. Activa automáticamente los limpiaparabrisas cuando detecta humedad o presencia de agua en el parabrisas, aumentando y disminuyendo la velocidad de barrido según la intensidad de la lluvia. Disponible en las versiones Ranger XLT y Ranger Limited',
							Image: require('./../assets/Galerias/28_RangerXLT/Bullet/7.webp'),
						},
						{
							Position: '-3.826 0.348 -0.461',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Diferencial trasero con bloqueo electrónico. Entrega la misma potencia a las ruedas traseras e incrementa la tracción para superar cualquier obstáculo. Ahora disponible en las versiones Ranger XL Chasis, XLS Diesel, XLT y Limited legal: Imágenes de referencia. Algunas características como estribos pueden variar con respecto a la versión que se comercializa en Colombia.',
							Image: require('./../assets/Galerias/28_RangerXLT/Bullet/6.webp'),
						},
						{
							Position: '-3.826 0.342 0.465',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'La Ranger cuenta con un motor 3.2L Diesel, capaz de desarrollar impresionantes 197 hp. Adicionalmente, ofrece un torque de 470 Nm.  Disponible en las versiones Ranger XL Doble Cabina, XLS Diesel, Ranger XLT y Ranger Limited',
							Image: require('./../assets/Galerias/28_RangerXLT/Bullet/9.webp'),
						},
					],
				},
				'RANGER XLT DIG DER': {
					Image: require('./../assets/panoramas/Desktop/RangerXLT_DiagonalDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.379 -0.129 -1.912',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XLT LAT DER',
						},
						{
							Position: '-3.505 -0.129 2.227',
							Rotation: '-90 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XLT POSTERIOR',
						},
					],
				},
				'RANGER XLT DIG IZQ': {
					Image: require('./../assets/panoramas/Desktop/RangerXLT_DiagonalIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [
						{
							Position: '-7.092 -0.129 10.287',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'FAMILIA EDGE',
						},
					],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.272 -0.129 -2.106',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLT LAT IZQ',
						},
						{
							Position: '-2.988 -0.129 1.709',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLT ',
						}
					],
				},
				'RANGER XLT LAT DER': {
					Image: require('./../assets/panoramas/Desktop/RangerXLT_LateralDer.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.822 -0.129 -4.464',
							Rotation: '-90 0 0',
							Scale: '0.537 0.537',
							goTo: 'RANGER XLT',
						},
						{
							Position: '-2.963 -0.129 2.835',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLT DIG DER',
						}
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.352 -2.530',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Al activar el comando sobre la consola central, el Control Electrónico de Descenso (HDC) asiste electrónicamente al conductor para mantener el control sin derrapar al descender por pendientes empinadas de baja adherencia. Disponible en las versiones XL Chasis, XL Doble Cabina, XLS Diesel, XLT y Limited legal: Imágenes de referencia. Algunas características como estribos pueden variar con respecto a la versión que se comercializa en Colombia',
							Image: require('./../assets/Galerias/28_RangerXLT/Bullet/10.webp'),
						},
					],
				},
				'RANGER XLT LAT IZQ': {
					Image: require('./../assets/panoramas/Desktop/RangerXLT_LateralIzq.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-4.514 -0.129 -4.080',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLT POSTERIOR',
						},
						{
							Position: '-2.785 -0.129 3.169',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLT DIG IZQ',
						},
						{
							Position: '-4.339 -0.129 4.550',
							Rotation: '-90 0 0',
							Scale: '0.4 0.4',
							goTo: 'RANGER XLT ',
						}
					],
					BulletsInfo: [
						{
							Position: '-3.826 0.352 2.530',
							Rotation: '0 90 0',
							Scale: '0.1 0.1',
							Text: 'Al activar el comando sobre la consola central, el Control Electrónico de Descenso (HDC) asiste electrónicamente al conductor para mantener el control sin derrapar al descender por pendientes empinadas de baja adherencia. Disponible en las versiones XL Chasis, XL Doble Cabina, XLS Diesel, XLT y Limited legal: Imágenes de referencia. Algunas características como estribos pueden variar con respecto a la versión que se comercializa en Colombia',
							Image: require('./../assets/Galerias/28_RangerXLT/Bullet/10.webp'),
						},
					],
				},
				'RANGER XLT POSTERIOR': {
					Image: require('./../assets/panoramas/Desktop/RangerXLT_Posterior.webp'),
					Rotation: '0 90 0',
					Bullets: [],
					BulletsDesplazamiento: [],
					BulletsIndividual: [
						{
							Position: '-1.829 -0.129 -1.234',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XLT DIG DER',
						},
						{
							Position: '-4.686 -0.129 2.718',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XLT LAT IZQ',
						},
						{
							Position: '-6.108 -0.129 -3.734',
							Rotation: '-90.000 0 0',
							Scale: '0.3 0.3',
							goTo: 'RANGER XLT LAT DER',
						},
					],
					BulletsInfo: [
					],
				},
			},
		];
	},
};
